var _path, _path2, _g, _g2, _path3, _path4, _g3, _g4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 120,
    viewBox: "0 0 214 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.16,
    d: "M200.331 73.9957C199.351 78.4762 197.051 82.5766 193.65 86.2369C192.47 87.517 191.15 88.7571 189.73 89.9772C168.508 108.039 122.044 117.48 78.8995 107.099C73.019 105.679 67.1984 103.899 61.4979 101.718C35.0155 91.5574 13.0334 73.8758 5.63275 50.5336C-3.26808 22.451 25.3546 -9.752 64.9782 2.78916C92.3808 11.45 111.083 39.7726 134.405 37.1323C187.81 31.1118 205.131 52.0737 200.331 73.9957Z",
    fill: "#4182EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.1,
    d: "M189.749 89.9773C168.527 108.039 122.063 117.48 78.9189 107.099L65.5977 95.9778L134.444 37.1523L189.749 89.9773Z",
    fill: "#7189C5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M92.2397 37.7124C78.5584 37.7124 64.7771 35.0121 52.1359 29.8317C36.6145 23.4711 23.5133 13.5501 14.2324 1.08899L14.9925 0.528931C24.1733 12.8301 37.1345 22.671 52.496 28.9516C66.4573 34.6721 81.8187 37.3323 96.8801 36.6523L96.9201 37.5924C95.3599 37.6724 93.7998 37.7124 92.2397 37.7124Z",
    fill: "#262730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.7387 71.5755L96.88 37.5323L73.2578 35.1921L82.7387 71.5755Z",
    fill: "url(#paint0_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.375 58.8344L64.2571 33.212L41.495 24.3112L41.375 58.8344Z",
    fill: "url(#paint1_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.851562 33.0519L31.6744 17.5705L14.6128 0.80896L0.851562 33.0519Z",
    fill: "url(#paint2_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M72.978 35.9322L73.078 34.9121C73.118 34.412 73.578 34.052 74.0781 34.132C81.0787 35.2521 88.6594 35.8722 96.6202 36.1322C97.1202 36.1522 97.5003 36.5922 97.4603 37.0923L97.3603 38.1324C97.3203 38.5924 96.9402 38.9324 96.4802 38.9324C88.7395 38.9524 81.1187 38.3124 73.6781 36.8923C73.258 36.7923 72.938 36.3922 72.978 35.9322Z",
    fill: "#2DDC88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.1948 24.9112L41.7148 23.6111C41.8748 23.231 42.3149 23.091 42.6549 23.291C48.4755 26.8114 55.5761 29.7716 63.9569 31.8718C64.3369 31.9719 64.5569 32.3919 64.4169 32.7519L63.8969 34.052C63.7769 34.3721 63.4168 34.5321 63.0968 34.4321C55.0361 32.0318 47.6754 29.2316 41.4748 25.7313C41.1948 25.5712 41.0748 25.2312 41.1948 24.9112Z",
    fill: "url(#paint3_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.1733 0.968959L15.0134 0.308888C15.3734 0.0288618 15.8934 0.108879 16.1735 0.468912C20.1338 5.90942 25.7744 11.3099 32.255 16.5504C32.635 16.8504 32.655 17.4105 32.315 17.7505L31.5149 18.5506C31.2149 18.8506 30.7548 18.8706 30.4148 18.6106C24.1542 13.4701 18.6337 7.64957 14.0333 2.10905C13.7533 1.76902 13.8133 1.24898 14.1733 0.968959Z",
    fill: "url(#paint4_linear_85_12546)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M119.443 89.3972C118.003 89.3972 116.563 89.3573 115.143 89.2773L115.203 88.3372C130.544 89.1573 146.385 85.4969 161.047 77.7162C174.388 70.6355 186.249 60.5546 195.37 48.5535L196.13 49.1335C186.929 61.2547 174.948 71.4356 161.487 78.5763C148.046 85.6769 133.584 89.3972 119.443 89.3972Z",
    fill: "#262730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M213.15 81.7366L196.049 49.0935L179.127 65.7551L213.15 81.7366Z",
    fill: "url(#paint5_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M176.868 105.379L171.827 71.3756L150.445 83.1767L176.868 105.379Z",
    fill: "url(#paint6_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M131.144 120L138.964 86.397L115.162 88.7972L131.144 120Z",
    fill: "url(#paint7_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M179.529 66.4351L178.809 65.7151C178.449 65.355 178.469 64.775 178.849 64.435C184.189 59.7745 189.51 54.334 194.81 48.4135C195.15 48.0334 195.73 48.0134 196.09 48.3735L196.83 49.1135C197.15 49.4336 197.17 49.9536 196.89 50.2936C191.93 56.2542 186.569 61.6947 180.729 66.5151C180.349 66.7752 179.849 66.7352 179.529 66.4351Z",
    fill: "url(#paint8_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M150.706 83.7967L150.045 82.5566C149.845 82.1966 150.025 81.7566 150.406 81.6166C156.826 79.3964 163.667 75.836 170.627 70.7356C170.947 70.4956 171.407 70.5955 171.587 70.9556L172.248 72.1957C172.408 72.4957 172.308 72.8757 172.027 73.0558C165.027 77.7162 158.146 81.5765 151.486 84.0968C151.206 84.2168 150.866 84.0768 150.706 83.7967Z",
    fill: "url(#paint9_linear_85_12546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M115.002 89.2172L115.042 88.1571C115.062 87.697 115.442 87.337 115.902 87.377C122.623 87.8171 130.363 86.937 138.564 85.3168C139.044 85.2168 139.484 85.5569 139.524 86.0369L139.624 87.157C139.664 87.577 139.384 87.9571 138.964 88.0371C131.003 89.5572 123.003 90.0573 115.802 90.0773C115.362 90.0573 115.002 89.6772 115.002 89.2172Z",
    fill: "url(#paint10_linear_85_12546)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M94.4396 106.039C120.024 106.039 140.764 85.2986 140.764 59.7144C140.764 34.1302 120.024 13.3901 94.4396 13.3901C68.8553 13.3901 48.1152 34.1302 48.1152 59.7144C48.1152 85.2986 68.8553 106.039 94.4396 106.039Z",
    fill: "#36907C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M93.6192 102.758C119.203 102.758 139.944 82.0184 139.944 56.4342C139.944 30.85 119.203 10.1099 93.6192 10.1099C68.035 10.1099 47.2949 30.85 47.2949 56.4342C47.2949 82.0184 68.035 102.758 93.6192 102.758Z",
    fill: "url(#paint11_linear_85_12546)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_12546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 10,
    width: 93,
    height: 93
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000178186658077045855490000012475925880575300499_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M93.6192 102.758C119.203 102.758 139.944 82.0184 139.944 56.4342C139.944 30.85 119.203 10.1099 93.6192 10.1099C68.035 10.1099 47.2949 30.85 47.2949 56.4342C47.2949 82.0184 68.035 102.758 93.6192 102.758Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_12546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M49.8739 10.8299H49.1738C48.8538 10.8299 48.5938 10.5699 48.5938 10.2498V9.54976C48.5938 9.22973 48.8538 8.96973 49.1738 8.96973H49.8739C50.1939 8.96973 50.4539 9.22973 50.4539 9.54976V10.2498C50.4739 10.5699 50.1939 10.8299 49.8739 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M49.8739 15.5503H49.1738C48.8538 15.5503 48.5938 15.2903 48.5938 14.9703V14.2702C48.5938 13.9502 48.8538 13.6902 49.1738 13.6902H49.8739C50.1939 13.6902 50.4539 13.9502 50.4539 14.2702V14.9703C50.4739 15.2703 50.1939 15.5503 49.8739 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M49.8739 20.2508H49.1738C48.8538 20.2508 48.5938 19.9908 48.5938 19.6707V18.9707C48.5938 18.6507 48.8538 18.3906 49.1738 18.3906H49.8739C50.1939 18.3906 50.4539 18.6507 50.4539 18.9707V19.6707C50.4739 19.9908 50.1939 20.2508 49.8739 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M49.8739 24.9512H49.1738C48.8538 24.9512 48.5938 24.6912 48.5938 24.3712V23.6711C48.5938 23.3511 48.8538 23.0911 49.1738 23.0911H49.8739C50.1939 23.0911 50.4539 23.3511 50.4539 23.6711V24.3712C50.4739 24.6912 50.1939 24.9512 49.8739 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M49.8739 29.6717H49.1738C48.8538 29.6717 48.5938 29.4117 48.5938 29.0916V28.3916C48.5938 28.0716 48.8538 27.8115 49.1738 27.8115H49.8739C50.1939 27.8115 50.4539 28.0716 50.4539 28.3916V29.0916C50.4739 29.4117 50.1939 29.6717 49.8739 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M49.8739 34.3721H49.1738C48.8538 34.3721 48.5938 34.1121 48.5938 33.7921V33.092C48.5938 32.772 48.8538 32.512 49.1738 32.512H49.8739C50.1939 32.512 50.4539 32.772 50.4539 33.092V33.7921C50.4739 34.1121 50.1939 34.3721 49.8739 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M49.8739 39.0925H49.1738C48.8538 39.0925 48.5938 38.8325 48.5938 38.5124V37.8124C48.5938 37.4923 48.8538 37.2323 49.1738 37.2323H49.8739C50.1939 37.2323 50.4539 37.4923 50.4539 37.8124V38.5124C50.4739 38.8125 50.1939 39.0925 49.8739 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M49.8739 43.7929H49.1738C48.8538 43.7929 48.5938 43.5329 48.5938 43.2129V42.5128C48.5938 42.1928 48.8538 41.9327 49.1738 41.9327H49.8739C50.1939 41.9327 50.4539 42.1928 50.4539 42.5128V43.2129C50.4739 43.5329 50.1939 43.7929 49.8739 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M49.8739 48.4933H49.1738C48.8538 48.4933 48.5938 48.2333 48.5938 47.9133V47.2132C48.5938 46.8932 48.8538 46.6332 49.1738 46.6332H49.8739C50.1939 46.6332 50.4539 46.8932 50.4539 47.2132V47.9133C50.4739 48.2333 50.1939 48.4933 49.8739 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M49.8739 53.2138H49.1738C48.8538 53.2138 48.5938 52.9538 48.5938 52.6338V51.9337C48.5938 51.6137 48.8538 51.3536 49.1738 51.3536H49.8739C50.1939 51.3536 50.4539 51.6137 50.4539 51.9337V52.6338C50.4739 52.9538 50.1939 53.2138 49.8739 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M49.8739 57.9143H49.1738C48.8538 57.9143 48.5938 57.6543 48.5938 57.3342V56.6342C48.5938 56.3141 48.8538 56.0541 49.1738 56.0541H49.8739C50.1939 56.0541 50.4539 56.3141 50.4539 56.6342V57.3342C50.4739 57.6543 50.1939 57.9143 49.8739 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M49.8739 62.6347H49.1738C48.8538 62.6347 48.5938 62.3747 48.5938 62.0546V61.3546C48.5938 61.0345 48.8538 60.7745 49.1738 60.7745H49.8739C50.1939 60.7745 50.4539 61.0345 50.4539 61.3546V62.0546C50.4739 62.3547 50.1939 62.6347 49.8739 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M49.8739 67.3352H49.1738C48.8538 67.3352 48.5938 67.0751 48.5938 66.7551V66.055C48.5938 65.735 48.8538 65.475 49.1738 65.475H49.8739C50.1939 65.475 50.4539 65.735 50.4539 66.055V66.7551C50.4739 67.0751 50.1939 67.3352 49.8739 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M49.8739 72.0356H49.1738C48.8538 72.0356 48.5938 71.7755 48.5938 71.4555V70.7554C48.5938 70.4354 48.8538 70.1754 49.1738 70.1754H49.8739C50.1939 70.1754 50.4539 70.4354 50.4539 70.7554V71.4555C50.4739 71.7755 50.1939 72.0356 49.8739 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M49.8739 76.7559H49.1738C48.8538 76.7559 48.5938 76.4959 48.5938 76.1759V75.4758C48.5938 75.1558 48.8538 74.8958 49.1738 74.8958H49.8739C50.1939 74.8958 50.4539 75.1558 50.4539 75.4758V76.1759C50.4739 76.4759 50.1939 76.7559 49.8739 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M49.8739 81.4564H49.1738C48.8538 81.4564 48.5938 81.1964 48.5938 80.8763V80.1763C48.5938 79.8562 48.8538 79.5962 49.1738 79.5962H49.8739C50.1939 79.5962 50.4539 79.8562 50.4539 80.1763V80.8763C50.4739 81.1964 50.1939 81.4564 49.8739 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M49.8739 86.1568H49.1738C48.8538 86.1568 48.5938 85.8968 48.5938 85.5768V84.8767C48.5938 84.5567 48.8538 84.2966 49.1738 84.2966H49.8739C50.1939 84.2966 50.4539 84.5567 50.4539 84.8767V85.5768C50.4739 85.8968 50.1939 86.1568 49.8739 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M49.8739 90.8773H49.1738C48.8538 90.8773 48.5938 90.6172 48.5938 90.2972V89.5971C48.5938 89.2771 48.8538 89.0171 49.1738 89.0171H49.8739C50.1939 89.0171 50.4539 89.2771 50.4539 89.5971V90.2972C50.4739 90.6172 50.1939 90.8773 49.8739 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M49.8739 95.5777H49.1738C48.8538 95.5777 48.5938 95.3177 48.5938 94.9976V94.2976C48.5938 93.9775 48.8538 93.7175 49.1738 93.7175H49.8739C50.1939 93.7175 50.4539 93.9775 50.4539 94.2976V94.9976C50.4739 95.3177 50.1939 95.5777 49.8739 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M49.8739 100.298H49.1738C48.8538 100.298 48.5938 100.038 48.5938 99.7181V99.018C48.5938 98.698 48.8538 98.438 49.1738 98.438H49.8739C50.1939 98.438 50.4539 98.698 50.4539 99.018V99.7181C50.4739 100.018 50.1939 100.298 49.8739 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M53.3543 13.1501H52.6543C52.3342 13.1501 52.0742 12.8901 52.0742 12.57V11.87C52.0742 11.5499 52.3342 11.2899 52.6543 11.2899H53.3543C53.6744 11.2899 53.9344 11.5499 53.9344 11.87V12.57C53.9344 12.8901 53.6744 13.1501 53.3543 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M53.3543 17.8505H52.6543C52.3342 17.8505 52.0742 17.5905 52.0742 17.2705V16.5704C52.0742 16.2504 52.3342 15.9904 52.6543 15.9904H53.3543C53.6744 15.9904 53.9344 16.2504 53.9344 16.5704V17.2705C53.9344 17.5905 53.6744 17.8505 53.3543 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M53.3543 22.571H52.6543C52.3342 22.571 52.0742 22.311 52.0742 21.9909V21.2909C52.0742 20.9708 52.3342 20.7108 52.6543 20.7108H53.3543C53.6744 20.7108 53.9344 20.9708 53.9344 21.2909V21.9909C53.9344 22.311 53.6744 22.571 53.3543 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M53.3543 27.2714H52.6543C52.3342 27.2714 52.0742 27.0114 52.0742 26.6914V25.9913C52.0742 25.6713 52.3342 25.4113 52.6543 25.4113H53.3543C53.6744 25.4113 53.9344 25.6713 53.9344 25.9913V26.6914C53.9344 27.0114 53.6744 27.2714 53.3543 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M53.3543 31.9919H52.6543C52.3342 31.9919 52.0742 31.7319 52.0742 31.4118V30.7118C52.0742 30.3917 52.3342 30.1317 52.6543 30.1317H53.3543C53.6744 30.1317 53.9344 30.3917 53.9344 30.7118V31.4118C53.9344 31.7119 53.6744 31.9919 53.3543 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M53.3543 36.6923H52.6543C52.3342 36.6923 52.0742 36.4323 52.0742 36.1123V35.4122C52.0742 35.0922 52.3342 34.8322 52.6543 34.8322H53.3543C53.6744 34.8322 53.9344 35.0922 53.9344 35.4122V36.1123C53.9344 36.4323 53.6744 36.6923 53.3543 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M53.3543 41.3928H52.6543C52.3342 41.3928 52.0742 41.1327 52.0742 40.8127V40.1127C52.0742 39.7926 52.3342 39.5326 52.6543 39.5326H53.3543C53.6744 39.5326 53.9344 39.7926 53.9344 40.1127V40.8127C53.9344 41.1327 53.6744 41.3928 53.3543 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M53.3543 46.1131H52.6543C52.3342 46.1131 52.0742 45.8531 52.0742 45.5331V44.833C52.0742 44.513 52.3342 44.2529 52.6543 44.2529H53.3543C53.6744 44.2529 53.9344 44.513 53.9344 44.833V45.5331C53.9344 45.8531 53.6744 46.1131 53.3543 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M53.3543 50.8136H52.6543C52.3342 50.8136 52.0742 50.5535 52.0742 50.2335V49.5335C52.0742 49.2134 52.3342 48.9534 52.6543 48.9534H53.3543C53.6744 48.9534 53.9344 49.2134 53.9344 49.5335V50.2335C53.9344 50.5535 53.6744 50.8136 53.3543 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M53.3543 55.534H52.6543C52.3342 55.534 52.0742 55.274 52.0742 54.9539V54.2539C52.0742 53.9338 52.3342 53.6738 52.6543 53.6738H53.3543C53.6744 53.6738 53.9344 53.9338 53.9344 54.2539V54.9539C53.9344 55.254 53.6744 55.534 53.3543 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M53.3543 60.2344H52.6543C52.3342 60.2344 52.0742 59.9744 52.0742 59.6544V58.9543C52.0742 58.6343 52.3342 58.3743 52.6543 58.3743H53.3543C53.6744 58.3743 53.9344 58.6343 53.9344 58.9543V59.6544C53.9344 59.9744 53.6744 60.2344 53.3543 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M53.3543 64.9349H52.6543C52.3342 64.9349 52.0742 64.6748 52.0742 64.3548V63.6547C52.0742 63.3347 52.3342 63.0747 52.6543 63.0747H53.3543C53.6744 63.0747 53.9344 63.3347 53.9344 63.6547V64.3548C53.9344 64.6748 53.6744 64.9349 53.3543 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M53.3543 69.6553H52.6543C52.3342 69.6553 52.0742 69.3953 52.0742 69.0753V68.3752C52.0742 68.0552 52.3342 67.7952 52.6543 67.7952H53.3543C53.6744 67.7952 53.9344 68.0552 53.9344 68.3752V69.0753C53.9344 69.3953 53.6744 69.6553 53.3543 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M53.3543 74.3558H52.6543C52.3342 74.3558 52.0742 74.0958 52.0742 73.7758V73.0757C52.0742 72.7557 52.3342 72.4956 52.6543 72.4956H53.3543C53.6744 72.4956 53.9344 72.7557 53.9344 73.0757V73.7758C53.9344 74.0958 53.6744 74.3558 53.3543 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M53.3543 79.0762H52.6543C52.3342 79.0762 52.0742 78.8162 52.0742 78.4962V77.7961C52.0742 77.4761 52.3342 77.2161 52.6543 77.2161H53.3543C53.6744 77.2161 53.9344 77.4761 53.9344 77.7961V78.4962C53.9344 78.7962 53.6744 79.0762 53.3543 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M53.3543 83.7767H52.6543C52.3342 83.7767 52.0742 83.5166 52.0742 83.1966V82.4965C52.0742 82.1765 52.3342 81.9165 52.6543 81.9165H53.3543C53.6744 81.9165 53.9344 82.1765 53.9344 82.4965V83.1966C53.9344 83.5166 53.6744 83.7767 53.3543 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M53.3543 88.4771H52.6543C52.3342 88.4771 52.0742 88.2171 52.0742 87.897V87.197C52.0742 86.8769 52.3342 86.6169 52.6543 86.6169H53.3543C53.6744 86.6169 53.9344 86.8769 53.9344 87.197V87.897C53.9344 88.2171 53.6744 88.4771 53.3543 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M53.3543 93.1975H52.6543C52.3342 93.1975 52.0742 92.9375 52.0742 92.6175V91.9174C52.0742 91.5974 52.3342 91.3374 52.6543 91.3374H53.3543C53.6744 91.3374 53.9344 91.5974 53.9344 91.9174V92.6175C53.9344 92.9375 53.6744 93.1975 53.3543 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M53.3543 97.898H52.6543C52.3342 97.898 52.0742 97.638 52.0742 97.3179V96.6179C52.0742 96.2978 52.3342 96.0378 52.6543 96.0378H53.3543C53.6744 96.0378 53.9344 96.2978 53.9344 96.6179V97.3179C53.9344 97.638 53.6744 97.898 53.3543 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M53.3543 102.618H52.6543C52.3342 102.618 52.0742 102.358 52.0742 102.038V101.338C52.0742 101.018 52.3342 100.758 52.6543 100.758H53.3543C53.6744 100.758 53.9344 101.018 53.9344 101.338V102.038C53.9344 102.338 53.6744 102.618 53.3543 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M56.6961 10.8299H55.9961C55.676 10.8299 55.416 10.5699 55.416 10.2498V9.54976C55.416 9.22973 55.676 8.96973 55.9961 8.96973H56.6961C57.0162 8.96973 57.2762 9.22973 57.2762 9.54976V10.2498C57.2762 10.5699 57.0162 10.8299 56.6961 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M56.6961 15.5503H55.9961C55.676 15.5503 55.416 15.2903 55.416 14.9703V14.2702C55.416 13.9502 55.676 13.6902 55.9961 13.6902H56.6961C57.0162 13.6902 57.2762 13.9502 57.2762 14.2702V14.9703C57.2762 15.2703 57.0162 15.5503 56.6961 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M56.6961 20.2508H55.9961C55.676 20.2508 55.416 19.9908 55.416 19.6707V18.9707C55.416 18.6507 55.676 18.3906 55.9961 18.3906H56.6961C57.0162 18.3906 57.2762 18.6507 57.2762 18.9707V19.6707C57.2762 19.9908 57.0162 20.2508 56.6961 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M56.6961 24.9512H55.9961C55.676 24.9512 55.416 24.6912 55.416 24.3712V23.6711C55.416 23.3511 55.676 23.0911 55.9961 23.0911H56.6961C57.0162 23.0911 57.2762 23.3511 57.2762 23.6711V24.3712C57.2762 24.6912 57.0162 24.9512 56.6961 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M56.6961 29.6717H55.9961C55.676 29.6717 55.416 29.4117 55.416 29.0916V28.3916C55.416 28.0716 55.676 27.8115 55.9961 27.8115H56.6961C57.0162 27.8115 57.2762 28.0716 57.2762 28.3916V29.0916C57.2762 29.4117 57.0162 29.6717 56.6961 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M56.6961 34.3721H55.9961C55.676 34.3721 55.416 34.1121 55.416 33.7921V33.092C55.416 32.772 55.676 32.512 55.9961 32.512H56.6961C57.0162 32.512 57.2762 32.772 57.2762 33.092V33.7921C57.2762 34.1121 57.0162 34.3721 56.6961 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M56.6961 39.0925H55.9961C55.676 39.0925 55.416 38.8325 55.416 38.5124V37.8124C55.416 37.4923 55.676 37.2323 55.9961 37.2323H56.6961C57.0162 37.2323 57.2762 37.4923 57.2762 37.8124V38.5124C57.2762 38.8125 57.0162 39.0925 56.6961 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M56.6961 43.7929H55.9961C55.676 43.7929 55.416 43.5329 55.416 43.2129V42.5128C55.416 42.1928 55.676 41.9327 55.9961 41.9327H56.6961C57.0162 41.9327 57.2762 42.1928 57.2762 42.5128V43.2129C57.2762 43.5329 57.0162 43.7929 56.6961 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M56.6961 48.4933H55.9961C55.676 48.4933 55.416 48.2333 55.416 47.9133V47.2132C55.416 46.8932 55.676 46.6332 55.9961 46.6332H56.6961C57.0162 46.6332 57.2762 46.8932 57.2762 47.2132V47.9133C57.2762 48.2333 57.0162 48.4933 56.6961 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M56.6961 53.2138H55.9961C55.676 53.2138 55.416 52.9538 55.416 52.6338V51.9337C55.416 51.6137 55.676 51.3536 55.9961 51.3536H56.6961C57.0162 51.3536 57.2762 51.6137 57.2762 51.9337V52.6338C57.2762 52.9538 57.0162 53.2138 56.6961 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M56.6961 57.9143H55.9961C55.676 57.9143 55.416 57.6543 55.416 57.3342V56.6342C55.416 56.3141 55.676 56.0541 55.9961 56.0541H56.6961C57.0162 56.0541 57.2762 56.3141 57.2762 56.6342V57.3342C57.2762 57.6543 57.0162 57.9143 56.6961 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M56.6961 62.6347H55.9961C55.676 62.6347 55.416 62.3747 55.416 62.0546V61.3546C55.416 61.0345 55.676 60.7745 55.9961 60.7745H56.6961C57.0162 60.7745 57.2762 61.0345 57.2762 61.3546V62.0546C57.2762 62.3547 57.0162 62.6347 56.6961 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M56.6961 67.3352H55.9961C55.676 67.3352 55.416 67.0751 55.416 66.7551V66.055C55.416 65.735 55.676 65.475 55.9961 65.475H56.6961C57.0162 65.475 57.2762 65.735 57.2762 66.055V66.7551C57.2762 67.0751 57.0162 67.3352 56.6961 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M56.6961 72.0356H55.9961C55.676 72.0356 55.416 71.7755 55.416 71.4555V70.7554C55.416 70.4354 55.676 70.1754 55.9961 70.1754H56.6961C57.0162 70.1754 57.2762 70.4354 57.2762 70.7554V71.4555C57.2762 71.7755 57.0162 72.0356 56.6961 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M56.6961 76.7559H55.9961C55.676 76.7559 55.416 76.4959 55.416 76.1759V75.4758C55.416 75.1558 55.676 74.8958 55.9961 74.8958H56.6961C57.0162 74.8958 57.2762 75.1558 57.2762 75.4758V76.1759C57.2762 76.4759 57.0162 76.7559 56.6961 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M56.6961 81.4564H55.9961C55.676 81.4564 55.416 81.1964 55.416 80.8763V80.1763C55.416 79.8562 55.676 79.5962 55.9961 79.5962H56.6961C57.0162 79.5962 57.2762 79.8562 57.2762 80.1763V80.8763C57.2762 81.1964 57.0162 81.4564 56.6961 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M56.6961 86.1568H55.9961C55.676 86.1568 55.416 85.8968 55.416 85.5768V84.8767C55.416 84.5567 55.676 84.2966 55.9961 84.2966H56.6961C57.0162 84.2966 57.2762 84.5567 57.2762 84.8767V85.5768C57.2762 85.8968 57.0162 86.1568 56.6961 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M56.6961 90.8773H55.9961C55.676 90.8773 55.416 90.6172 55.416 90.2972V89.5971C55.416 89.2771 55.676 89.0171 55.9961 89.0171H56.6961C57.0162 89.0171 57.2762 89.2771 57.2762 89.5971V90.2972C57.2762 90.6172 57.0162 90.8773 56.6961 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M56.6961 95.5777H55.9961C55.676 95.5777 55.416 95.3177 55.416 94.9976V94.2976C55.416 93.9775 55.676 93.7175 55.9961 93.7175H56.6961C57.0162 93.7175 57.2762 93.9775 57.2762 94.2976V94.9976C57.2762 95.3177 57.0162 95.5777 56.6961 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M56.6961 100.298H55.9961C55.676 100.298 55.416 100.038 55.416 99.7181V99.018C55.416 98.698 55.676 98.438 55.9961 98.438H56.6961C57.0162 98.438 57.2762 98.698 57.2762 99.018V99.7181C57.2762 100.018 57.0162 100.298 56.6961 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M60.1747 13.1501H59.4746C59.1546 13.1501 58.8945 12.8901 58.8945 12.57V11.87C58.8945 11.5499 59.1546 11.2899 59.4746 11.2899H60.1747C60.4947 11.2899 60.7547 11.5499 60.7547 11.87V12.57C60.7547 12.8901 60.4947 13.1501 60.1747 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M60.1747 17.8505H59.4746C59.1546 17.8505 58.8945 17.5905 58.8945 17.2705V16.5704C58.8945 16.2504 59.1546 15.9904 59.4746 15.9904H60.1747C60.4947 15.9904 60.7547 16.2504 60.7547 16.5704V17.2705C60.7547 17.5905 60.4947 17.8505 60.1747 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M60.1747 22.571H59.4746C59.1546 22.571 58.8945 22.311 58.8945 21.9909V21.2909C58.8945 20.9708 59.1546 20.7108 59.4746 20.7108H60.1747C60.4947 20.7108 60.7547 20.9708 60.7547 21.2909V21.9909C60.7547 22.311 60.4947 22.571 60.1747 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M60.1747 27.2714H59.4746C59.1546 27.2714 58.8945 27.0114 58.8945 26.6914V25.9913C58.8945 25.6713 59.1546 25.4113 59.4746 25.4113H60.1747C60.4947 25.4113 60.7547 25.6713 60.7547 25.9913V26.6914C60.7547 27.0114 60.4947 27.2714 60.1747 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M60.1747 31.9919H59.4746C59.1546 31.9919 58.8945 31.7319 58.8945 31.4118V30.7118C58.8945 30.3917 59.1546 30.1317 59.4746 30.1317H60.1747C60.4947 30.1317 60.7547 30.3917 60.7547 30.7118V31.4118C60.7547 31.7119 60.4947 31.9919 60.1747 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M60.1747 36.6923H59.4746C59.1546 36.6923 58.8945 36.4323 58.8945 36.1123V35.4122C58.8945 35.0922 59.1546 34.8322 59.4746 34.8322H60.1747C60.4947 34.8322 60.7547 35.0922 60.7547 35.4122V36.1123C60.7547 36.4323 60.4947 36.6923 60.1747 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M60.1747 41.3928H59.4746C59.1546 41.3928 58.8945 41.1327 58.8945 40.8127V40.1127C58.8945 39.7926 59.1546 39.5326 59.4746 39.5326H60.1747C60.4947 39.5326 60.7547 39.7926 60.7547 40.1127V40.8127C60.7547 41.1327 60.4947 41.3928 60.1747 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M60.1747 46.1131H59.4746C59.1546 46.1131 58.8945 45.8531 58.8945 45.5331V44.833C58.8945 44.513 59.1546 44.2529 59.4746 44.2529H60.1747C60.4947 44.2529 60.7547 44.513 60.7547 44.833V45.5331C60.7547 45.8531 60.4947 46.1131 60.1747 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M60.1747 50.8136H59.4746C59.1546 50.8136 58.8945 50.5535 58.8945 50.2335V49.5335C58.8945 49.2134 59.1546 48.9534 59.4746 48.9534H60.1747C60.4947 48.9534 60.7547 49.2134 60.7547 49.5335V50.2335C60.7547 50.5535 60.4947 50.8136 60.1747 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M60.1747 55.534H59.4746C59.1546 55.534 58.8945 55.274 58.8945 54.9539V54.2539C58.8945 53.9338 59.1546 53.6738 59.4746 53.6738H60.1747C60.4947 53.6738 60.7547 53.9338 60.7547 54.2539V54.9539C60.7547 55.254 60.4947 55.534 60.1747 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M60.1747 60.2344H59.4746C59.1546 60.2344 58.8945 59.9744 58.8945 59.6544V58.9543C58.8945 58.6343 59.1546 58.3743 59.4746 58.3743H60.1747C60.4947 58.3743 60.7547 58.6343 60.7547 58.9543V59.6544C60.7547 59.9744 60.4947 60.2344 60.1747 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M60.1747 64.9349H59.4746C59.1546 64.9349 58.8945 64.6748 58.8945 64.3548V63.6547C58.8945 63.3347 59.1546 63.0747 59.4746 63.0747H60.1747C60.4947 63.0747 60.7547 63.3347 60.7547 63.6547V64.3548C60.7547 64.6748 60.4947 64.9349 60.1747 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M60.1747 69.6553H59.4746C59.1546 69.6553 58.8945 69.3953 58.8945 69.0753V68.3752C58.8945 68.0552 59.1546 67.7952 59.4746 67.7952H60.1747C60.4947 67.7952 60.7547 68.0552 60.7547 68.3752V69.0753C60.7547 69.3953 60.4947 69.6553 60.1747 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M60.1747 74.3558H59.4746C59.1546 74.3558 58.8945 74.0958 58.8945 73.7758V73.0757C58.8945 72.7557 59.1546 72.4956 59.4746 72.4956H60.1747C60.4947 72.4956 60.7547 72.7557 60.7547 73.0757V73.7758C60.7547 74.0958 60.4947 74.3558 60.1747 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M60.1747 79.0762H59.4746C59.1546 79.0762 58.8945 78.8162 58.8945 78.4962V77.7961C58.8945 77.4761 59.1546 77.2161 59.4746 77.2161H60.1747C60.4947 77.2161 60.7547 77.4761 60.7547 77.7961V78.4962C60.7547 78.7962 60.4947 79.0762 60.1747 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M60.1747 83.7767H59.4746C59.1546 83.7767 58.8945 83.5166 58.8945 83.1966V82.4965C58.8945 82.1765 59.1546 81.9165 59.4746 81.9165H60.1747C60.4947 81.9165 60.7547 82.1765 60.7547 82.4965V83.1966C60.7547 83.5166 60.4947 83.7767 60.1747 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M60.1747 88.4771H59.4746C59.1546 88.4771 58.8945 88.2171 58.8945 87.897V87.197C58.8945 86.8769 59.1546 86.6169 59.4746 86.6169H60.1747C60.4947 86.6169 60.7547 86.8769 60.7547 87.197V87.897C60.7547 88.2171 60.4947 88.4771 60.1747 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M60.1747 93.1975H59.4746C59.1546 93.1975 58.8945 92.9375 58.8945 92.6175V91.9174C58.8945 91.5974 59.1546 91.3374 59.4746 91.3374H60.1747C60.4947 91.3374 60.7547 91.5974 60.7547 91.9174V92.6175C60.7547 92.9375 60.4947 93.1975 60.1747 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M60.1747 97.898H59.4746C59.1546 97.898 58.8945 97.638 58.8945 97.3179V96.6179C58.8945 96.2978 59.1546 96.0378 59.4746 96.0378H60.1747C60.4947 96.0378 60.7547 96.2978 60.7547 96.6179V97.3179C60.7547 97.638 60.4947 97.898 60.1747 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M60.1747 102.618H59.4746C59.1546 102.618 58.8945 102.358 58.8945 102.038V101.338C58.8945 101.018 59.1546 100.758 59.4746 100.758H60.1747C60.4947 100.758 60.7547 101.018 60.7547 101.338V102.038C60.7547 102.338 60.4947 102.618 60.1747 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M63.5164 10.8299H62.8164C62.4963 10.8299 62.2363 10.5699 62.2363 10.2498V9.54976C62.2363 9.22973 62.4963 8.96973 62.8164 8.96973H63.5164C63.8365 8.96973 64.0965 9.22973 64.0965 9.54976V10.2498C64.0965 10.5699 63.8365 10.8299 63.5164 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M63.5164 15.5503H62.8164C62.4963 15.5503 62.2363 15.2903 62.2363 14.9703V14.2702C62.2363 13.9502 62.4963 13.6902 62.8164 13.6902H63.5164C63.8365 13.6902 64.0965 13.9502 64.0965 14.2702V14.9703C64.0965 15.2703 63.8365 15.5503 63.5164 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M63.5164 20.2508H62.8164C62.4963 20.2508 62.2363 19.9908 62.2363 19.6707V18.9707C62.2363 18.6507 62.4963 18.3906 62.8164 18.3906H63.5164C63.8365 18.3906 64.0965 18.6507 64.0965 18.9707V19.6707C64.0965 19.9908 63.8365 20.2508 63.5164 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M63.5164 24.9512H62.8164C62.4963 24.9512 62.2363 24.6912 62.2363 24.3712V23.6711C62.2363 23.3511 62.4963 23.0911 62.8164 23.0911H63.5164C63.8365 23.0911 64.0965 23.3511 64.0965 23.6711V24.3712C64.0965 24.6912 63.8365 24.9512 63.5164 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M63.5164 29.6717H62.8164C62.4963 29.6717 62.2363 29.4117 62.2363 29.0916V28.3916C62.2363 28.0716 62.4963 27.8115 62.8164 27.8115H63.5164C63.8365 27.8115 64.0965 28.0716 64.0965 28.3916V29.0916C64.0965 29.4117 63.8365 29.6717 63.5164 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M63.5164 34.3721H62.8164C62.4963 34.3721 62.2363 34.1121 62.2363 33.7921V33.092C62.2363 32.772 62.4963 32.512 62.8164 32.512H63.5164C63.8365 32.512 64.0965 32.772 64.0965 33.092V33.7921C64.0965 34.1121 63.8365 34.3721 63.5164 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M63.5164 39.0925H62.8164C62.4963 39.0925 62.2363 38.8325 62.2363 38.5124V37.8124C62.2363 37.4923 62.4963 37.2323 62.8164 37.2323H63.5164C63.8365 37.2323 64.0965 37.4923 64.0965 37.8124V38.5124C64.0965 38.8125 63.8365 39.0925 63.5164 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M63.5164 43.7929H62.8164C62.4963 43.7929 62.2363 43.5329 62.2363 43.2129V42.5128C62.2363 42.1928 62.4963 41.9327 62.8164 41.9327H63.5164C63.8365 41.9327 64.0965 42.1928 64.0965 42.5128V43.2129C64.0965 43.5329 63.8365 43.7929 63.5164 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M63.5164 48.4933H62.8164C62.4963 48.4933 62.2363 48.2333 62.2363 47.9133V47.2132C62.2363 46.8932 62.4963 46.6332 62.8164 46.6332H63.5164C63.8365 46.6332 64.0965 46.8932 64.0965 47.2132V47.9133C64.0965 48.2333 63.8365 48.4933 63.5164 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M63.5164 53.2138H62.8164C62.4963 53.2138 62.2363 52.9538 62.2363 52.6338V51.9337C62.2363 51.6137 62.4963 51.3536 62.8164 51.3536H63.5164C63.8365 51.3536 64.0965 51.6137 64.0965 51.9337V52.6338C64.0965 52.9538 63.8365 53.2138 63.5164 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M63.5164 57.9143H62.8164C62.4963 57.9143 62.2363 57.6543 62.2363 57.3342V56.6342C62.2363 56.3141 62.4963 56.0541 62.8164 56.0541H63.5164C63.8365 56.0541 64.0965 56.3141 64.0965 56.6342V57.3342C64.0965 57.6543 63.8365 57.9143 63.5164 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M63.5164 62.6347H62.8164C62.4963 62.6347 62.2363 62.3747 62.2363 62.0546V61.3546C62.2363 61.0345 62.4963 60.7745 62.8164 60.7745H63.5164C63.8365 60.7745 64.0965 61.0345 64.0965 61.3546V62.0546C64.0965 62.3547 63.8365 62.6347 63.5164 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M63.5164 67.3352H62.8164C62.4963 67.3352 62.2363 67.0751 62.2363 66.7551V66.055C62.2363 65.735 62.4963 65.475 62.8164 65.475H63.5164C63.8365 65.475 64.0965 65.735 64.0965 66.055V66.7551C64.0965 67.0751 63.8365 67.3352 63.5164 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M63.5164 72.0356H62.8164C62.4963 72.0356 62.2363 71.7755 62.2363 71.4555V70.7554C62.2363 70.4354 62.4963 70.1754 62.8164 70.1754H63.5164C63.8365 70.1754 64.0965 70.4354 64.0965 70.7554V71.4555C64.0965 71.7755 63.8365 72.0356 63.5164 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M63.5164 76.7559H62.8164C62.4963 76.7559 62.2363 76.4959 62.2363 76.1759V75.4758C62.2363 75.1558 62.4963 74.8958 62.8164 74.8958H63.5164C63.8365 74.8958 64.0965 75.1558 64.0965 75.4758V76.1759C64.0965 76.4759 63.8365 76.7559 63.5164 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M63.5164 81.4564H62.8164C62.4963 81.4564 62.2363 81.1964 62.2363 80.8763V80.1763C62.2363 79.8562 62.4963 79.5962 62.8164 79.5962H63.5164C63.8365 79.5962 64.0965 79.8562 64.0965 80.1763V80.8763C64.0965 81.1964 63.8365 81.4564 63.5164 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M63.5164 86.1568H62.8164C62.4963 86.1568 62.2363 85.8968 62.2363 85.5768V84.8767C62.2363 84.5567 62.4963 84.2966 62.8164 84.2966H63.5164C63.8365 84.2966 64.0965 84.5567 64.0965 84.8767V85.5768C64.0965 85.8968 63.8365 86.1568 63.5164 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M63.5164 90.8773H62.8164C62.4963 90.8773 62.2363 90.6172 62.2363 90.2972V89.5971C62.2363 89.2771 62.4963 89.0171 62.8164 89.0171H63.5164C63.8365 89.0171 64.0965 89.2771 64.0965 89.5971V90.2972C64.0965 90.6172 63.8365 90.8773 63.5164 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M63.5164 95.5777H62.8164C62.4963 95.5777 62.2363 95.3177 62.2363 94.9976V94.2976C62.2363 93.9775 62.4963 93.7175 62.8164 93.7175H63.5164C63.8365 93.7175 64.0965 93.9775 64.0965 94.2976V94.9976C64.0965 95.3177 63.8365 95.5777 63.5164 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M63.5164 100.298H62.8164C62.4963 100.298 62.2363 100.038 62.2363 99.7181V99.018C62.2363 98.698 62.4963 98.438 62.8164 98.438H63.5164C63.8365 98.438 64.0965 98.698 64.0965 99.018V99.7181C64.0965 100.018 63.8365 100.298 63.5164 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M66.9754 13.1501H66.2754C65.9553 13.1501 65.6953 12.8901 65.6953 12.57V11.87C65.6953 11.5499 65.9553 11.2899 66.2754 11.2899H66.9754C67.2955 11.2899 67.5555 11.5499 67.5555 11.87V12.57C67.5755 12.8901 67.3155 13.1501 66.9754 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M66.9754 17.8505H66.2754C65.9553 17.8505 65.6953 17.5905 65.6953 17.2705V16.5704C65.6953 16.2504 65.9553 15.9904 66.2754 15.9904H66.9754C67.2955 15.9904 67.5555 16.2504 67.5555 16.5704V17.2705C67.5755 17.5905 67.3155 17.8505 66.9754 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M66.9754 22.571H66.2754C65.9553 22.571 65.6953 22.311 65.6953 21.9909V21.2909C65.6953 20.9708 65.9553 20.7108 66.2754 20.7108H66.9754C67.2955 20.7108 67.5555 20.9708 67.5555 21.2909V21.9909C67.5755 22.311 67.3155 22.571 66.9754 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M66.9754 27.2714H66.2754C65.9553 27.2714 65.6953 27.0114 65.6953 26.6914V25.9913C65.6953 25.6713 65.9553 25.4113 66.2754 25.4113H66.9754C67.2955 25.4113 67.5555 25.6713 67.5555 25.9913V26.6914C67.5755 27.0114 67.3155 27.2714 66.9754 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M66.9754 31.9919H66.2754C65.9553 31.9919 65.6953 31.7319 65.6953 31.4118V30.7118C65.6953 30.3917 65.9553 30.1317 66.2754 30.1317H66.9754C67.2955 30.1317 67.5555 30.3917 67.5555 30.7118V31.4118C67.5755 31.7119 67.3155 31.9919 66.9754 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M66.9754 36.6923H66.2754C65.9553 36.6923 65.6953 36.4323 65.6953 36.1123V35.4122C65.6953 35.0922 65.9553 34.8322 66.2754 34.8322H66.9754C67.2955 34.8322 67.5555 35.0922 67.5555 35.4122V36.1123C67.5755 36.4323 67.3155 36.6923 66.9754 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M66.9754 41.3928H66.2754C65.9553 41.3928 65.6953 41.1327 65.6953 40.8127V40.1127C65.6953 39.7926 65.9553 39.5326 66.2754 39.5326H66.9754C67.2955 39.5326 67.5555 39.7926 67.5555 40.1127V40.8127C67.5755 41.1327 67.3155 41.3928 66.9754 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M66.9754 46.1131H66.2754C65.9553 46.1131 65.6953 45.8531 65.6953 45.5331V44.833C65.6953 44.513 65.9553 44.2529 66.2754 44.2529H66.9754C67.2955 44.2529 67.5555 44.513 67.5555 44.833V45.5331C67.5755 45.8531 67.3155 46.1131 66.9754 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M66.9754 50.8136H66.2754C65.9553 50.8136 65.6953 50.5535 65.6953 50.2335V49.5335C65.6953 49.2134 65.9553 48.9534 66.2754 48.9534H66.9754C67.2955 48.9534 67.5555 49.2134 67.5555 49.5335V50.2335C67.5755 50.5535 67.3155 50.8136 66.9754 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M66.9754 55.534H66.2754C65.9553 55.534 65.6953 55.274 65.6953 54.9539V54.2539C65.6953 53.9338 65.9553 53.6738 66.2754 53.6738H66.9754C67.2955 53.6738 67.5555 53.9338 67.5555 54.2539V54.9539C67.5755 55.254 67.3155 55.534 66.9754 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M66.9754 60.2344H66.2754C65.9553 60.2344 65.6953 59.9744 65.6953 59.6544V58.9543C65.6953 58.6343 65.9553 58.3743 66.2754 58.3743H66.9754C67.2955 58.3743 67.5555 58.6343 67.5555 58.9543V59.6544C67.5755 59.9744 67.3155 60.2344 66.9754 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M66.9754 64.9349H66.2754C65.9553 64.9349 65.6953 64.6748 65.6953 64.3548V63.6547C65.6953 63.3347 65.9553 63.0747 66.2754 63.0747H66.9754C67.2955 63.0747 67.5555 63.3347 67.5555 63.6547V64.3548C67.5755 64.6748 67.3155 64.9349 66.9754 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M66.9754 69.6553H66.2754C65.9553 69.6553 65.6953 69.3953 65.6953 69.0753V68.3752C65.6953 68.0552 65.9553 67.7952 66.2754 67.7952H66.9754C67.2955 67.7952 67.5555 68.0552 67.5555 68.3752V69.0753C67.5755 69.3953 67.3155 69.6553 66.9754 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M66.9754 74.3558H66.2754C65.9553 74.3558 65.6953 74.0958 65.6953 73.7758V73.0757C65.6953 72.7557 65.9553 72.4956 66.2754 72.4956H66.9754C67.2955 72.4956 67.5555 72.7557 67.5555 73.0757V73.7758C67.5755 74.0958 67.3155 74.3558 66.9754 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M66.9754 79.0762H66.2754C65.9553 79.0762 65.6953 78.8162 65.6953 78.4962V77.7961C65.6953 77.4761 65.9553 77.2161 66.2754 77.2161H66.9754C67.2955 77.2161 67.5555 77.4761 67.5555 77.7961V78.4962C67.5755 78.7962 67.3155 79.0762 66.9754 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M66.9754 83.7767H66.2754C65.9553 83.7767 65.6953 83.5166 65.6953 83.1966V82.4965C65.6953 82.1765 65.9553 81.9165 66.2754 81.9165H66.9754C67.2955 81.9165 67.5555 82.1765 67.5555 82.4965V83.1966C67.5755 83.5166 67.3155 83.7767 66.9754 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M66.9754 88.4771H66.2754C65.9553 88.4771 65.6953 88.2171 65.6953 87.897V87.197C65.6953 86.8769 65.9553 86.6169 66.2754 86.6169H66.9754C67.2955 86.6169 67.5555 86.8769 67.5555 87.197V87.897C67.5755 88.2171 67.3155 88.4771 66.9754 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M66.9754 93.1975H66.2754C65.9553 93.1975 65.6953 92.9375 65.6953 92.6175V91.9174C65.6953 91.5974 65.9553 91.3374 66.2754 91.3374H66.9754C67.2955 91.3374 67.5555 91.5974 67.5555 91.9174V92.6175C67.5755 92.9375 67.3155 93.1975 66.9754 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M66.9754 97.898H66.2754C65.9553 97.898 65.6953 97.638 65.6953 97.3179V96.6179C65.6953 96.2978 65.9553 96.0378 66.2754 96.0378H66.9754C67.2955 96.0378 67.5555 96.2978 67.5555 96.6179V97.3179C67.5755 97.638 67.3155 97.898 66.9754 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M66.9754 102.618H66.2754C65.9553 102.618 65.6953 102.358 65.6953 102.038V101.338C65.6953 101.018 65.9553 100.758 66.2754 100.758H66.9754C67.2955 100.758 67.5555 101.018 67.5555 101.338V102.038C67.5755 102.338 67.3155 102.618 66.9754 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M70.3368 10.8299H69.6367C69.3167 10.8299 69.0566 10.5699 69.0566 10.2498V9.54976C69.0566 9.22973 69.3167 8.96973 69.6367 8.96973H70.3368C70.6568 8.96973 70.9168 9.22973 70.9168 9.54976V10.2498C70.9168 10.5699 70.6568 10.8299 70.3368 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M70.3368 15.5503H69.6367C69.3167 15.5503 69.0566 15.2903 69.0566 14.9703V14.2702C69.0566 13.9502 69.3167 13.6902 69.6367 13.6902H70.3368C70.6568 13.6902 70.9168 13.9502 70.9168 14.2702V14.9703C70.9168 15.2703 70.6568 15.5503 70.3368 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M70.3368 20.2508H69.6367C69.3167 20.2508 69.0566 19.9908 69.0566 19.6707V18.9707C69.0566 18.6507 69.3167 18.3906 69.6367 18.3906H70.3368C70.6568 18.3906 70.9168 18.6507 70.9168 18.9707V19.6707C70.9168 19.9908 70.6568 20.2508 70.3368 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M70.3368 24.9512H69.6367C69.3167 24.9512 69.0566 24.6912 69.0566 24.3712V23.6711C69.0566 23.3511 69.3167 23.0911 69.6367 23.0911H70.3368C70.6568 23.0911 70.9168 23.3511 70.9168 23.6711V24.3712C70.9168 24.6912 70.6568 24.9512 70.3368 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M70.3368 29.6717H69.6367C69.3167 29.6717 69.0566 29.4117 69.0566 29.0916V28.3916C69.0566 28.0716 69.3167 27.8115 69.6367 27.8115H70.3368C70.6568 27.8115 70.9168 28.0716 70.9168 28.3916V29.0916C70.9168 29.4117 70.6568 29.6717 70.3368 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M70.3368 34.3721H69.6367C69.3167 34.3721 69.0566 34.1121 69.0566 33.7921V33.092C69.0566 32.772 69.3167 32.512 69.6367 32.512H70.3368C70.6568 32.512 70.9168 32.772 70.9168 33.092V33.7921C70.9168 34.1121 70.6568 34.3721 70.3368 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M70.3368 39.0925H69.6367C69.3167 39.0925 69.0566 38.8325 69.0566 38.5124V37.8124C69.0566 37.4923 69.3167 37.2323 69.6367 37.2323H70.3368C70.6568 37.2323 70.9168 37.4923 70.9168 37.8124V38.5124C70.9168 38.8125 70.6568 39.0925 70.3368 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M70.3368 43.7929H69.6367C69.3167 43.7929 69.0566 43.5329 69.0566 43.2129V42.5128C69.0566 42.1928 69.3167 41.9327 69.6367 41.9327H70.3368C70.6568 41.9327 70.9168 42.1928 70.9168 42.5128V43.2129C70.9168 43.5329 70.6568 43.7929 70.3368 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M70.3368 48.4933H69.6367C69.3167 48.4933 69.0566 48.2333 69.0566 47.9133V47.2132C69.0566 46.8932 69.3167 46.6332 69.6367 46.6332H70.3368C70.6568 46.6332 70.9168 46.8932 70.9168 47.2132V47.9133C70.9168 48.2333 70.6568 48.4933 70.3368 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M70.3368 53.2138H69.6367C69.3167 53.2138 69.0566 52.9538 69.0566 52.6338V51.9337C69.0566 51.6137 69.3167 51.3536 69.6367 51.3536H70.3368C70.6568 51.3536 70.9168 51.6137 70.9168 51.9337V52.6338C70.9168 52.9538 70.6568 53.2138 70.3368 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M70.3368 57.9143H69.6367C69.3167 57.9143 69.0566 57.6543 69.0566 57.3342V56.6342C69.0566 56.3141 69.3167 56.0541 69.6367 56.0541H70.3368C70.6568 56.0541 70.9168 56.3141 70.9168 56.6342V57.3342C70.9168 57.6543 70.6568 57.9143 70.3368 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M70.3368 62.6347H69.6367C69.3167 62.6347 69.0566 62.3747 69.0566 62.0546V61.3546C69.0566 61.0345 69.3167 60.7745 69.6367 60.7745H70.3368C70.6568 60.7745 70.9168 61.0345 70.9168 61.3546V62.0546C70.9168 62.3547 70.6568 62.6347 70.3368 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M70.3368 67.3352H69.6367C69.3167 67.3352 69.0566 67.0751 69.0566 66.7551V66.055C69.0566 65.735 69.3167 65.475 69.6367 65.475H70.3368C70.6568 65.475 70.9168 65.735 70.9168 66.055V66.7551C70.9168 67.0751 70.6568 67.3352 70.3368 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M70.3368 72.0356H69.6367C69.3167 72.0356 69.0566 71.7755 69.0566 71.4555V70.7554C69.0566 70.4354 69.3167 70.1754 69.6367 70.1754H70.3368C70.6568 70.1754 70.9168 70.4354 70.9168 70.7554V71.4555C70.9168 71.7755 70.6568 72.0356 70.3368 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M70.3368 76.7559H69.6367C69.3167 76.7559 69.0566 76.4959 69.0566 76.1759V75.4758C69.0566 75.1558 69.3167 74.8958 69.6367 74.8958H70.3368C70.6568 74.8958 70.9168 75.1558 70.9168 75.4758V76.1759C70.9168 76.4759 70.6568 76.7559 70.3368 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M70.3368 81.4564H69.6367C69.3167 81.4564 69.0566 81.1964 69.0566 80.8763V80.1763C69.0566 79.8562 69.3167 79.5962 69.6367 79.5962H70.3368C70.6568 79.5962 70.9168 79.8562 70.9168 80.1763V80.8763C70.9168 81.1964 70.6568 81.4564 70.3368 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M70.3368 86.1568H69.6367C69.3167 86.1568 69.0566 85.8968 69.0566 85.5768V84.8767C69.0566 84.5567 69.3167 84.2966 69.6367 84.2966H70.3368C70.6568 84.2966 70.9168 84.5567 70.9168 84.8767V85.5768C70.9168 85.8968 70.6568 86.1568 70.3368 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M70.3368 90.8773H69.6367C69.3167 90.8773 69.0566 90.6172 69.0566 90.2972V89.5971C69.0566 89.2771 69.3167 89.0171 69.6367 89.0171H70.3368C70.6568 89.0171 70.9168 89.2771 70.9168 89.5971V90.2972C70.9168 90.6172 70.6568 90.8773 70.3368 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M70.3368 95.5777H69.6367C69.3167 95.5777 69.0566 95.3177 69.0566 94.9976V94.2976C69.0566 93.9775 69.3167 93.7175 69.6367 93.7175H70.3368C70.6568 93.7175 70.9168 93.9775 70.9168 94.2976V94.9976C70.9168 95.3177 70.6568 95.5777 70.3368 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M70.3368 100.298H69.6367C69.3167 100.298 69.0566 100.038 69.0566 99.7181V99.018C69.0566 98.698 69.3167 98.438 69.6367 98.438H70.3368C70.6568 98.438 70.9168 98.698 70.9168 99.018V99.7181C70.9168 100.018 70.6568 100.298 70.3368 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M73.7977 13.1501H73.0976C72.7776 13.1501 72.5176 12.8901 72.5176 12.57V11.87C72.5176 11.5499 72.7776 11.2899 73.0976 11.2899H73.7977C74.1177 11.2899 74.3778 11.5499 74.3778 11.87V12.57C74.3978 12.8901 74.1377 13.1501 73.7977 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M73.7977 17.8505H73.0976C72.7776 17.8505 72.5176 17.5905 72.5176 17.2705V16.5704C72.5176 16.2504 72.7776 15.9904 73.0976 15.9904H73.7977C74.1177 15.9904 74.3778 16.2504 74.3778 16.5704V17.2705C74.3978 17.5905 74.1377 17.8505 73.7977 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M73.7977 22.571H73.0976C72.7776 22.571 72.5176 22.311 72.5176 21.9909V21.2909C72.5176 20.9708 72.7776 20.7108 73.0976 20.7108H73.7977C74.1177 20.7108 74.3778 20.9708 74.3778 21.2909V21.9909C74.3978 22.311 74.1377 22.571 73.7977 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M73.7977 27.2714H73.0976C72.7776 27.2714 72.5176 27.0114 72.5176 26.6914V25.9913C72.5176 25.6713 72.7776 25.4113 73.0976 25.4113H73.7977C74.1177 25.4113 74.3778 25.6713 74.3778 25.9913V26.6914C74.3978 27.0114 74.1377 27.2714 73.7977 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M73.7977 31.9919H73.0976C72.7776 31.9919 72.5176 31.7319 72.5176 31.4118V30.7118C72.5176 30.3917 72.7776 30.1317 73.0976 30.1317H73.7977C74.1177 30.1317 74.3778 30.3917 74.3778 30.7118V31.4118C74.3978 31.7119 74.1377 31.9919 73.7977 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M73.7977 36.6923H73.0976C72.7776 36.6923 72.5176 36.4323 72.5176 36.1123V35.4122C72.5176 35.0922 72.7776 34.8322 73.0976 34.8322H73.7977C74.1177 34.8322 74.3778 35.0922 74.3778 35.4122V36.1123C74.3978 36.4323 74.1377 36.6923 73.7977 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M73.7977 41.3928H73.0976C72.7776 41.3928 72.5176 41.1327 72.5176 40.8127V40.1127C72.5176 39.7926 72.7776 39.5326 73.0976 39.5326H73.7977C74.1177 39.5326 74.3778 39.7926 74.3778 40.1127V40.8127C74.3978 41.1327 74.1377 41.3928 73.7977 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M73.7977 46.1131H73.0976C72.7776 46.1131 72.5176 45.8531 72.5176 45.5331V44.833C72.5176 44.513 72.7776 44.2529 73.0976 44.2529H73.7977C74.1177 44.2529 74.3778 44.513 74.3778 44.833V45.5331C74.3978 45.8531 74.1377 46.1131 73.7977 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M73.7977 50.8136H73.0976C72.7776 50.8136 72.5176 50.5535 72.5176 50.2335V49.5335C72.5176 49.2134 72.7776 48.9534 73.0976 48.9534H73.7977C74.1177 48.9534 74.3778 49.2134 74.3778 49.5335V50.2335C74.3978 50.5535 74.1377 50.8136 73.7977 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M73.7977 55.534H73.0976C72.7776 55.534 72.5176 55.274 72.5176 54.9539V54.2539C72.5176 53.9338 72.7776 53.6738 73.0976 53.6738H73.7977C74.1177 53.6738 74.3778 53.9338 74.3778 54.2539V54.9539C74.3978 55.254 74.1377 55.534 73.7977 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M73.7977 60.2344H73.0976C72.7776 60.2344 72.5176 59.9744 72.5176 59.6544V58.9543C72.5176 58.6343 72.7776 58.3743 73.0976 58.3743H73.7977C74.1177 58.3743 74.3778 58.6343 74.3778 58.9543V59.6544C74.3978 59.9744 74.1377 60.2344 73.7977 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M73.7977 64.9349H73.0976C72.7776 64.9349 72.5176 64.6748 72.5176 64.3548V63.6547C72.5176 63.3347 72.7776 63.0747 73.0976 63.0747H73.7977C74.1177 63.0747 74.3778 63.3347 74.3778 63.6547V64.3548C74.3978 64.6748 74.1377 64.9349 73.7977 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M73.7977 69.6553H73.0976C72.7776 69.6553 72.5176 69.3953 72.5176 69.0753V68.3752C72.5176 68.0552 72.7776 67.7952 73.0976 67.7952H73.7977C74.1177 67.7952 74.3778 68.0552 74.3778 68.3752V69.0753C74.3978 69.3953 74.1377 69.6553 73.7977 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M73.7977 74.3558H73.0976C72.7776 74.3558 72.5176 74.0958 72.5176 73.7758V73.0757C72.5176 72.7557 72.7776 72.4956 73.0976 72.4956H73.7977C74.1177 72.4956 74.3778 72.7557 74.3778 73.0757V73.7758C74.3978 74.0958 74.1377 74.3558 73.7977 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M73.7977 79.0762H73.0976C72.7776 79.0762 72.5176 78.8162 72.5176 78.4962V77.7961C72.5176 77.4761 72.7776 77.2161 73.0976 77.2161H73.7977C74.1177 77.2161 74.3778 77.4761 74.3778 77.7961V78.4962C74.3978 78.7962 74.1377 79.0762 73.7977 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M73.7977 83.7767H73.0976C72.7776 83.7767 72.5176 83.5166 72.5176 83.1966V82.4965C72.5176 82.1765 72.7776 81.9165 73.0976 81.9165H73.7977C74.1177 81.9165 74.3778 82.1765 74.3778 82.4965V83.1966C74.3978 83.5166 74.1377 83.7767 73.7977 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M73.7977 88.4771H73.0976C72.7776 88.4771 72.5176 88.2171 72.5176 87.897V87.197C72.5176 86.8769 72.7776 86.6169 73.0976 86.6169H73.7977C74.1177 86.6169 74.3778 86.8769 74.3778 87.197V87.897C74.3978 88.2171 74.1377 88.4771 73.7977 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M73.7977 93.1975H73.0976C72.7776 93.1975 72.5176 92.9375 72.5176 92.6175V91.9174C72.5176 91.5974 72.7776 91.3374 73.0976 91.3374H73.7977C74.1177 91.3374 74.3778 91.5974 74.3778 91.9174V92.6175C74.3978 92.9375 74.1377 93.1975 73.7977 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M73.7977 97.898H73.0976C72.7776 97.898 72.5176 97.638 72.5176 97.3179V96.6179C72.5176 96.2978 72.7776 96.0378 73.0976 96.0378H73.7977C74.1177 96.0378 74.3778 96.2978 74.3778 96.6179V97.3179C74.3978 97.638 74.1377 97.898 73.7977 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M73.7977 102.618H73.0976C72.7776 102.618 72.5176 102.358 72.5176 102.038V101.338C72.5176 101.018 72.7776 100.758 73.0976 100.758H73.7977C74.1177 100.758 74.3778 101.018 74.3778 101.338V102.038C74.3978 102.338 74.1377 102.618 73.7977 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M77.1375 10.8299H76.4375C76.1175 10.8299 75.8574 10.5699 75.8574 10.2498V9.54976C75.8574 9.22973 76.1175 8.96973 76.4375 8.96973H77.1375C77.4576 8.96973 77.7176 9.22973 77.7176 9.54976V10.2498C77.7376 10.5699 77.4776 10.8299 77.1375 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M77.1375 15.5503H76.4375C76.1175 15.5503 75.8574 15.2903 75.8574 14.9703V14.2702C75.8574 13.9502 76.1175 13.6902 76.4375 13.6902H77.1375C77.4576 13.6902 77.7176 13.9502 77.7176 14.2702V14.9703C77.7376 15.2703 77.4776 15.5503 77.1375 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M77.1375 20.2508H76.4375C76.1175 20.2508 75.8574 19.9908 75.8574 19.6707V18.9707C75.8574 18.6507 76.1175 18.3906 76.4375 18.3906H77.1375C77.4576 18.3906 77.7176 18.6507 77.7176 18.9707V19.6707C77.7376 19.9908 77.4776 20.2508 77.1375 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M77.1375 24.9512H76.4375C76.1175 24.9512 75.8574 24.6912 75.8574 24.3712V23.6711C75.8574 23.3511 76.1175 23.0911 76.4375 23.0911H77.1375C77.4576 23.0911 77.7176 23.3511 77.7176 23.6711V24.3712C77.7376 24.6912 77.4776 24.9512 77.1375 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M77.1375 29.6717H76.4375C76.1175 29.6717 75.8574 29.4117 75.8574 29.0916V28.3916C75.8574 28.0716 76.1175 27.8115 76.4375 27.8115H77.1375C77.4576 27.8115 77.7176 28.0716 77.7176 28.3916V29.0916C77.7376 29.4117 77.4776 29.6717 77.1375 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M77.1375 34.3721H76.4375C76.1175 34.3721 75.8574 34.1121 75.8574 33.7921V33.092C75.8574 32.772 76.1175 32.512 76.4375 32.512H77.1375C77.4576 32.512 77.7176 32.772 77.7176 33.092V33.7921C77.7376 34.1121 77.4776 34.3721 77.1375 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M77.1375 39.0925H76.4375C76.1175 39.0925 75.8574 38.8325 75.8574 38.5124V37.8124C75.8574 37.4923 76.1175 37.2323 76.4375 37.2323H77.1375C77.4576 37.2323 77.7176 37.4923 77.7176 37.8124V38.5124C77.7376 38.8125 77.4776 39.0925 77.1375 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M77.1375 43.7929H76.4375C76.1175 43.7929 75.8574 43.5329 75.8574 43.2129V42.5128C75.8574 42.1928 76.1175 41.9327 76.4375 41.9327H77.1375C77.4576 41.9327 77.7176 42.1928 77.7176 42.5128V43.2129C77.7376 43.5329 77.4776 43.7929 77.1375 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M77.1375 48.4933H76.4375C76.1175 48.4933 75.8574 48.2333 75.8574 47.9133V47.2132C75.8574 46.8932 76.1175 46.6332 76.4375 46.6332H77.1375C77.4576 46.6332 77.7176 46.8932 77.7176 47.2132V47.9133C77.7376 48.2333 77.4776 48.4933 77.1375 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M77.1375 53.2138H76.4375C76.1175 53.2138 75.8574 52.9538 75.8574 52.6338V51.9337C75.8574 51.6137 76.1175 51.3536 76.4375 51.3536H77.1375C77.4576 51.3536 77.7176 51.6137 77.7176 51.9337V52.6338C77.7376 52.9538 77.4776 53.2138 77.1375 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M77.1375 57.9143H76.4375C76.1175 57.9143 75.8574 57.6543 75.8574 57.3342V56.6342C75.8574 56.3141 76.1175 56.0541 76.4375 56.0541H77.1375C77.4576 56.0541 77.7176 56.3141 77.7176 56.6342V57.3342C77.7376 57.6543 77.4776 57.9143 77.1375 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M77.1375 62.6347H76.4375C76.1175 62.6347 75.8574 62.3747 75.8574 62.0546V61.3546C75.8574 61.0345 76.1175 60.7745 76.4375 60.7745H77.1375C77.4576 60.7745 77.7176 61.0345 77.7176 61.3546V62.0546C77.7376 62.3547 77.4776 62.6347 77.1375 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M77.1375 67.3352H76.4375C76.1175 67.3352 75.8574 67.0751 75.8574 66.7551V66.055C75.8574 65.735 76.1175 65.475 76.4375 65.475H77.1375C77.4576 65.475 77.7176 65.735 77.7176 66.055V66.7551C77.7376 67.0751 77.4776 67.3352 77.1375 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M77.1375 72.0356H76.4375C76.1175 72.0356 75.8574 71.7755 75.8574 71.4555V70.7554C75.8574 70.4354 76.1175 70.1754 76.4375 70.1754H77.1375C77.4576 70.1754 77.7176 70.4354 77.7176 70.7554V71.4555C77.7376 71.7755 77.4776 72.0356 77.1375 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M77.1375 76.7559H76.4375C76.1175 76.7559 75.8574 76.4959 75.8574 76.1759V75.4758C75.8574 75.1558 76.1175 74.8958 76.4375 74.8958H77.1375C77.4576 74.8958 77.7176 75.1558 77.7176 75.4758V76.1759C77.7376 76.4759 77.4776 76.7559 77.1375 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M77.1375 81.4564H76.4375C76.1175 81.4564 75.8574 81.1964 75.8574 80.8763V80.1763C75.8574 79.8562 76.1175 79.5962 76.4375 79.5962H77.1375C77.4576 79.5962 77.7176 79.8562 77.7176 80.1763V80.8763C77.7376 81.1964 77.4776 81.4564 77.1375 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M77.1375 86.1568H76.4375C76.1175 86.1568 75.8574 85.8968 75.8574 85.5768V84.8767C75.8574 84.5567 76.1175 84.2966 76.4375 84.2966H77.1375C77.4576 84.2966 77.7176 84.5567 77.7176 84.8767V85.5768C77.7376 85.8968 77.4776 86.1568 77.1375 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M77.1375 90.8773H76.4375C76.1175 90.8773 75.8574 90.6172 75.8574 90.2972V89.5971C75.8574 89.2771 76.1175 89.0171 76.4375 89.0171H77.1375C77.4576 89.0171 77.7176 89.2771 77.7176 89.5971V90.2972C77.7376 90.6172 77.4776 90.8773 77.1375 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M77.1375 95.5777H76.4375C76.1175 95.5777 75.8574 95.3177 75.8574 94.9976V94.2976C75.8574 93.9775 76.1175 93.7175 76.4375 93.7175H77.1375C77.4576 93.7175 77.7176 93.9775 77.7176 94.2976V94.9976C77.7376 95.3177 77.4776 95.5777 77.1375 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M77.1375 100.298H76.4375C76.1175 100.298 75.8574 100.038 75.8574 99.7181V99.018C75.8574 98.698 76.1175 98.438 76.4375 98.438H77.1375C77.4576 98.438 77.7176 98.698 77.7176 99.018V99.7181C77.7376 100.018 77.4776 100.298 77.1375 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M80.618 13.1501H79.9179C79.5979 13.1501 79.3379 12.8901 79.3379 12.57V11.87C79.3379 11.5499 79.5979 11.2899 79.9179 11.2899H80.618C80.938 11.2899 81.198 11.5499 81.198 11.87V12.57C81.2181 12.8901 80.938 13.1501 80.618 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M80.618 17.8505H79.9179C79.5979 17.8505 79.3379 17.5905 79.3379 17.2705V16.5704C79.3379 16.2504 79.5979 15.9904 79.9179 15.9904H80.618C80.938 15.9904 81.198 16.2504 81.198 16.5704V17.2705C81.2181 17.5905 80.938 17.8505 80.618 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M80.618 22.571H79.9179C79.5979 22.571 79.3379 22.311 79.3379 21.9909V21.2909C79.3379 20.9708 79.5979 20.7108 79.9179 20.7108H80.618C80.938 20.7108 81.198 20.9708 81.198 21.2909V21.9909C81.2181 22.311 80.938 22.571 80.618 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M80.618 27.2714H79.9179C79.5979 27.2714 79.3379 27.0114 79.3379 26.6914V25.9913C79.3379 25.6713 79.5979 25.4113 79.9179 25.4113H80.618C80.938 25.4113 81.198 25.6713 81.198 25.9913V26.6914C81.2181 27.0114 80.938 27.2714 80.618 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M80.618 31.9919H79.9179C79.5979 31.9919 79.3379 31.7319 79.3379 31.4118V30.7118C79.3379 30.3917 79.5979 30.1317 79.9179 30.1317H80.618C80.938 30.1317 81.198 30.3917 81.198 30.7118V31.4118C81.2181 31.7119 80.938 31.9919 80.618 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M80.618 36.6923H79.9179C79.5979 36.6923 79.3379 36.4323 79.3379 36.1123V35.4122C79.3379 35.0922 79.5979 34.8322 79.9179 34.8322H80.618C80.938 34.8322 81.198 35.0922 81.198 35.4122V36.1123C81.2181 36.4323 80.938 36.6923 80.618 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M80.618 41.3928H79.9179C79.5979 41.3928 79.3379 41.1327 79.3379 40.8127V40.1127C79.3379 39.7926 79.5979 39.5326 79.9179 39.5326H80.618C80.938 39.5326 81.198 39.7926 81.198 40.1127V40.8127C81.2181 41.1327 80.938 41.3928 80.618 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M80.618 46.1131H79.9179C79.5979 46.1131 79.3379 45.8531 79.3379 45.5331V44.833C79.3379 44.513 79.5979 44.2529 79.9179 44.2529H80.618C80.938 44.2529 81.198 44.513 81.198 44.833V45.5331C81.2181 45.8531 80.938 46.1131 80.618 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M80.618 50.8136H79.9179C79.5979 50.8136 79.3379 50.5535 79.3379 50.2335V49.5335C79.3379 49.2134 79.5979 48.9534 79.9179 48.9534H80.618C80.938 48.9534 81.198 49.2134 81.198 49.5335V50.2335C81.2181 50.5535 80.938 50.8136 80.618 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M80.618 55.534H79.9179C79.5979 55.534 79.3379 55.274 79.3379 54.9539V54.2539C79.3379 53.9338 79.5979 53.6738 79.9179 53.6738H80.618C80.938 53.6738 81.198 53.9338 81.198 54.2539V54.9539C81.2181 55.254 80.938 55.534 80.618 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M80.618 60.2344H79.9179C79.5979 60.2344 79.3379 59.9744 79.3379 59.6544V58.9543C79.3379 58.6343 79.5979 58.3743 79.9179 58.3743H80.618C80.938 58.3743 81.198 58.6343 81.198 58.9543V59.6544C81.2181 59.9744 80.938 60.2344 80.618 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M80.618 64.9349H79.9179C79.5979 64.9349 79.3379 64.6748 79.3379 64.3548V63.6547C79.3379 63.3347 79.5979 63.0747 79.9179 63.0747H80.618C80.938 63.0747 81.198 63.3347 81.198 63.6547V64.3548C81.2181 64.6748 80.938 64.9349 80.618 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M80.618 69.6553H79.9179C79.5979 69.6553 79.3379 69.3953 79.3379 69.0753V68.3752C79.3379 68.0552 79.5979 67.7952 79.9179 67.7952H80.618C80.938 67.7952 81.198 68.0552 81.198 68.3752V69.0753C81.2181 69.3953 80.938 69.6553 80.618 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M80.618 74.3558H79.9179C79.5979 74.3558 79.3379 74.0958 79.3379 73.7758V73.0757C79.3379 72.7557 79.5979 72.4956 79.9179 72.4956H80.618C80.938 72.4956 81.198 72.7557 81.198 73.0757V73.7758C81.2181 74.0958 80.938 74.3558 80.618 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M80.618 79.0762H79.9179C79.5979 79.0762 79.3379 78.8162 79.3379 78.4962V77.7961C79.3379 77.4761 79.5979 77.2161 79.9179 77.2161H80.618C80.938 77.2161 81.198 77.4761 81.198 77.7961V78.4962C81.2181 78.7962 80.938 79.0762 80.618 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M80.618 83.7767H79.9179C79.5979 83.7767 79.3379 83.5166 79.3379 83.1966V82.4965C79.3379 82.1765 79.5979 81.9165 79.9179 81.9165H80.618C80.938 81.9165 81.198 82.1765 81.198 82.4965V83.1966C81.2181 83.5166 80.938 83.7767 80.618 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M80.618 88.4771H79.9179C79.5979 88.4771 79.3379 88.2171 79.3379 87.897V87.197C79.3379 86.8769 79.5979 86.6169 79.9179 86.6169H80.618C80.938 86.6169 81.198 86.8769 81.198 87.197V87.897C81.2181 88.2171 80.938 88.4771 80.618 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M80.618 93.1975H79.9179C79.5979 93.1975 79.3379 92.9375 79.3379 92.6175V91.9174C79.3379 91.5974 79.5979 91.3374 79.9179 91.3374H80.618C80.938 91.3374 81.198 91.5974 81.198 91.9174V92.6175C81.2181 92.9375 80.938 93.1975 80.618 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M80.618 97.898H79.9179C79.5979 97.898 79.3379 97.638 79.3379 97.3179V96.6179C79.3379 96.2978 79.5979 96.0378 79.9179 96.0378H80.618C80.938 96.0378 81.198 96.2978 81.198 96.6179V97.3179C81.2181 97.638 80.938 97.898 80.618 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M80.618 102.618H79.9179C79.5979 102.618 79.3379 102.358 79.3379 102.038V101.338C79.3379 101.018 79.5979 100.758 79.9179 100.758H80.618C80.938 100.758 81.198 101.018 81.198 101.338V102.038C81.2181 102.338 80.938 102.618 80.618 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M83.9579 10.8299H83.2578C82.9378 10.8299 82.6777 10.5699 82.6777 10.2498V9.54976C82.6777 9.22973 82.9378 8.96973 83.2578 8.96973H83.9579C84.2779 8.96973 84.5379 9.22973 84.5379 9.54976V10.2498C84.5579 10.5699 84.2979 10.8299 83.9579 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M83.9579 15.5503H83.2578C82.9378 15.5503 82.6777 15.2903 82.6777 14.9703V14.2702C82.6777 13.9502 82.9378 13.6902 83.2578 13.6902H83.9579C84.2779 13.6902 84.5379 13.9502 84.5379 14.2702V14.9703C84.5579 15.2703 84.2979 15.5503 83.9579 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M83.9579 20.2508H83.2578C82.9378 20.2508 82.6777 19.9908 82.6777 19.6707V18.9707C82.6777 18.6507 82.9378 18.3906 83.2578 18.3906H83.9579C84.2779 18.3906 84.5379 18.6507 84.5379 18.9707V19.6707C84.5579 19.9908 84.2979 20.2508 83.9579 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M83.9579 24.9512H83.2578C82.9378 24.9512 82.6777 24.6912 82.6777 24.3712V23.6711C82.6777 23.3511 82.9378 23.0911 83.2578 23.0911H83.9579C84.2779 23.0911 84.5379 23.3511 84.5379 23.6711V24.3712C84.5579 24.6912 84.2979 24.9512 83.9579 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M83.9579 29.6717H83.2578C82.9378 29.6717 82.6777 29.4117 82.6777 29.0916V28.3916C82.6777 28.0716 82.9378 27.8115 83.2578 27.8115H83.9579C84.2779 27.8115 84.5379 28.0716 84.5379 28.3916V29.0916C84.5579 29.4117 84.2979 29.6717 83.9579 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M83.9579 34.3721H83.2578C82.9378 34.3721 82.6777 34.1121 82.6777 33.7921V33.092C82.6777 32.772 82.9378 32.512 83.2578 32.512H83.9579C84.2779 32.512 84.5379 32.772 84.5379 33.092V33.7921C84.5579 34.1121 84.2979 34.3721 83.9579 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M83.9579 39.0925H83.2578C82.9378 39.0925 82.6777 38.8325 82.6777 38.5124V37.8124C82.6777 37.4923 82.9378 37.2323 83.2578 37.2323H83.9579C84.2779 37.2323 84.5379 37.4923 84.5379 37.8124V38.5124C84.5579 38.8125 84.2979 39.0925 83.9579 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M83.9579 43.7929H83.2578C82.9378 43.7929 82.6777 43.5329 82.6777 43.2129V42.5128C82.6777 42.1928 82.9378 41.9327 83.2578 41.9327H83.9579C84.2779 41.9327 84.5379 42.1928 84.5379 42.5128V43.2129C84.5579 43.5329 84.2979 43.7929 83.9579 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M83.9579 48.4933H83.2578C82.9378 48.4933 82.6777 48.2333 82.6777 47.9133V47.2132C82.6777 46.8932 82.9378 46.6332 83.2578 46.6332H83.9579C84.2779 46.6332 84.5379 46.8932 84.5379 47.2132V47.9133C84.5579 48.2333 84.2979 48.4933 83.9579 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M83.9579 53.2138H83.2578C82.9378 53.2138 82.6777 52.9538 82.6777 52.6338V51.9337C82.6777 51.6137 82.9378 51.3536 83.2578 51.3536H83.9579C84.2779 51.3536 84.5379 51.6137 84.5379 51.9337V52.6338C84.5579 52.9538 84.2979 53.2138 83.9579 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M83.9579 57.9143H83.2578C82.9378 57.9143 82.6777 57.6543 82.6777 57.3342V56.6342C82.6777 56.3141 82.9378 56.0541 83.2578 56.0541H83.9579C84.2779 56.0541 84.5379 56.3141 84.5379 56.6342V57.3342C84.5579 57.6543 84.2979 57.9143 83.9579 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M83.9579 62.6347H83.2578C82.9378 62.6347 82.6777 62.3747 82.6777 62.0546V61.3546C82.6777 61.0345 82.9378 60.7745 83.2578 60.7745H83.9579C84.2779 60.7745 84.5379 61.0345 84.5379 61.3546V62.0546C84.5579 62.3547 84.2979 62.6347 83.9579 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M83.9579 67.3352H83.2578C82.9378 67.3352 82.6777 67.0751 82.6777 66.7551V66.055C82.6777 65.735 82.9378 65.475 83.2578 65.475H83.9579C84.2779 65.475 84.5379 65.735 84.5379 66.055V66.7551C84.5579 67.0751 84.2979 67.3352 83.9579 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M83.9579 72.0356H83.2578C82.9378 72.0356 82.6777 71.7755 82.6777 71.4555V70.7554C82.6777 70.4354 82.9378 70.1754 83.2578 70.1754H83.9579C84.2779 70.1754 84.5379 70.4354 84.5379 70.7554V71.4555C84.5579 71.7755 84.2979 72.0356 83.9579 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M83.9579 76.7559H83.2578C82.9378 76.7559 82.6777 76.4959 82.6777 76.1759V75.4758C82.6777 75.1558 82.9378 74.8958 83.2578 74.8958H83.9579C84.2779 74.8958 84.5379 75.1558 84.5379 75.4758V76.1759C84.5579 76.4759 84.2979 76.7559 83.9579 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M83.9579 81.4564H83.2578C82.9378 81.4564 82.6777 81.1964 82.6777 80.8763V80.1763C82.6777 79.8562 82.9378 79.5962 83.2578 79.5962H83.9579C84.2779 79.5962 84.5379 79.8562 84.5379 80.1763V80.8763C84.5579 81.1964 84.2979 81.4564 83.9579 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M83.9579 86.1568H83.2578C82.9378 86.1568 82.6777 85.8968 82.6777 85.5768V84.8767C82.6777 84.5567 82.9378 84.2966 83.2578 84.2966H83.9579C84.2779 84.2966 84.5379 84.5567 84.5379 84.8767V85.5768C84.5579 85.8968 84.2979 86.1568 83.9579 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M83.9579 90.8773H83.2578C82.9378 90.8773 82.6777 90.6172 82.6777 90.2972V89.5971C82.6777 89.2771 82.9378 89.0171 83.2578 89.0171H83.9579C84.2779 89.0171 84.5379 89.2771 84.5379 89.5971V90.2972C84.5579 90.6172 84.2979 90.8773 83.9579 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M83.9579 95.5777H83.2578C82.9378 95.5777 82.6777 95.3177 82.6777 94.9976V94.2976C82.6777 93.9775 82.9378 93.7175 83.2578 93.7175H83.9579C84.2779 93.7175 84.5379 93.9775 84.5379 94.2976V94.9976C84.5579 95.3177 84.2979 95.5777 83.9579 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M83.9579 100.298H83.2578C82.9378 100.298 82.6777 100.038 82.6777 99.7181V99.018C82.6777 98.698 82.9378 98.438 83.2578 98.438H83.9579C84.2779 98.438 84.5379 98.698 84.5379 99.018V99.7181C84.5579 100.018 84.2979 100.298 83.9579 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M87.4383 13.1501H86.7383C86.4182 13.1501 86.1582 12.8901 86.1582 12.57V11.87C86.1582 11.5499 86.4182 11.2899 86.7383 11.2899H87.4383C87.7584 11.2899 88.0184 11.5499 88.0184 11.87V12.57C88.0184 12.8901 87.7584 13.1501 87.4383 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M87.4383 17.8505H86.7383C86.4182 17.8505 86.1582 17.5905 86.1582 17.2705V16.5704C86.1582 16.2504 86.4182 15.9904 86.7383 15.9904H87.4383C87.7584 15.9904 88.0184 16.2504 88.0184 16.5704V17.2705C88.0184 17.5905 87.7584 17.8505 87.4383 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M87.4383 22.571H86.7383C86.4182 22.571 86.1582 22.311 86.1582 21.9909V21.2909C86.1582 20.9708 86.4182 20.7108 86.7383 20.7108H87.4383C87.7584 20.7108 88.0184 20.9708 88.0184 21.2909V21.9909C88.0184 22.311 87.7584 22.571 87.4383 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M87.4383 27.2714H86.7383C86.4182 27.2714 86.1582 27.0114 86.1582 26.6914V25.9913C86.1582 25.6713 86.4182 25.4113 86.7383 25.4113H87.4383C87.7584 25.4113 88.0184 25.6713 88.0184 25.9913V26.6914C88.0184 27.0114 87.7584 27.2714 87.4383 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M87.4383 31.9919H86.7383C86.4182 31.9919 86.1582 31.7319 86.1582 31.4118V30.7118C86.1582 30.3917 86.4182 30.1317 86.7383 30.1317H87.4383C87.7584 30.1317 88.0184 30.3917 88.0184 30.7118V31.4118C88.0184 31.7119 87.7584 31.9919 87.4383 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M87.4383 36.6923H86.7383C86.4182 36.6923 86.1582 36.4323 86.1582 36.1123V35.4122C86.1582 35.0922 86.4182 34.8322 86.7383 34.8322H87.4383C87.7584 34.8322 88.0184 35.0922 88.0184 35.4122V36.1123C88.0184 36.4323 87.7584 36.6923 87.4383 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M87.4383 41.3928H86.7383C86.4182 41.3928 86.1582 41.1327 86.1582 40.8127V40.1127C86.1582 39.7926 86.4182 39.5326 86.7383 39.5326H87.4383C87.7584 39.5326 88.0184 39.7926 88.0184 40.1127V40.8127C88.0184 41.1327 87.7584 41.3928 87.4383 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M87.4383 46.1131H86.7383C86.4182 46.1131 86.1582 45.8531 86.1582 45.5331V44.833C86.1582 44.513 86.4182 44.2529 86.7383 44.2529H87.4383C87.7584 44.2529 88.0184 44.513 88.0184 44.833V45.5331C88.0184 45.8531 87.7584 46.1131 87.4383 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M87.4383 50.8136H86.7383C86.4182 50.8136 86.1582 50.5535 86.1582 50.2335V49.5335C86.1582 49.2134 86.4182 48.9534 86.7383 48.9534H87.4383C87.7584 48.9534 88.0184 49.2134 88.0184 49.5335V50.2335C88.0184 50.5535 87.7584 50.8136 87.4383 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M87.4383 55.534H86.7383C86.4182 55.534 86.1582 55.274 86.1582 54.9539V54.2539C86.1582 53.9338 86.4182 53.6738 86.7383 53.6738H87.4383C87.7584 53.6738 88.0184 53.9338 88.0184 54.2539V54.9539C88.0184 55.254 87.7584 55.534 87.4383 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M87.4383 60.2344H86.7383C86.4182 60.2344 86.1582 59.9744 86.1582 59.6544V58.9543C86.1582 58.6343 86.4182 58.3743 86.7383 58.3743H87.4383C87.7584 58.3743 88.0184 58.6343 88.0184 58.9543V59.6544C88.0184 59.9744 87.7584 60.2344 87.4383 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M87.4383 64.9349H86.7383C86.4182 64.9349 86.1582 64.6748 86.1582 64.3548V63.6547C86.1582 63.3347 86.4182 63.0747 86.7383 63.0747H87.4383C87.7584 63.0747 88.0184 63.3347 88.0184 63.6547V64.3548C88.0184 64.6748 87.7584 64.9349 87.4383 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M87.4383 69.6553H86.7383C86.4182 69.6553 86.1582 69.3953 86.1582 69.0753V68.3752C86.1582 68.0552 86.4182 67.7952 86.7383 67.7952H87.4383C87.7584 67.7952 88.0184 68.0552 88.0184 68.3752V69.0753C88.0184 69.3953 87.7584 69.6553 87.4383 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M87.4383 74.3558H86.7383C86.4182 74.3558 86.1582 74.0958 86.1582 73.7758V73.0757C86.1582 72.7557 86.4182 72.4956 86.7383 72.4956H87.4383C87.7584 72.4956 88.0184 72.7557 88.0184 73.0757V73.7758C88.0184 74.0958 87.7584 74.3558 87.4383 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M87.4383 79.0762H86.7383C86.4182 79.0762 86.1582 78.8162 86.1582 78.4962V77.7961C86.1582 77.4761 86.4182 77.2161 86.7383 77.2161H87.4383C87.7584 77.2161 88.0184 77.4761 88.0184 77.7961V78.4962C88.0184 78.7962 87.7584 79.0762 87.4383 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M87.4383 83.7767H86.7383C86.4182 83.7767 86.1582 83.5166 86.1582 83.1966V82.4965C86.1582 82.1765 86.4182 81.9165 86.7383 81.9165H87.4383C87.7584 81.9165 88.0184 82.1765 88.0184 82.4965V83.1966C88.0184 83.5166 87.7584 83.7767 87.4383 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M87.4383 88.4771H86.7383C86.4182 88.4771 86.1582 88.2171 86.1582 87.897V87.197C86.1582 86.8769 86.4182 86.6169 86.7383 86.6169H87.4383C87.7584 86.6169 88.0184 86.8769 88.0184 87.197V87.897C88.0184 88.2171 87.7584 88.4771 87.4383 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M87.4383 93.1975H86.7383C86.4182 93.1975 86.1582 92.9375 86.1582 92.6175V91.9174C86.1582 91.5974 86.4182 91.3374 86.7383 91.3374H87.4383C87.7584 91.3374 88.0184 91.5974 88.0184 91.9174V92.6175C88.0184 92.9375 87.7584 93.1975 87.4383 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M87.4383 97.898H86.7383C86.4182 97.898 86.1582 97.638 86.1582 97.3179V96.6179C86.1582 96.2978 86.4182 96.0378 86.7383 96.0378H87.4383C87.7584 96.0378 88.0184 96.2978 88.0184 96.6179V97.3179C88.0184 97.638 87.7584 97.898 87.4383 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M87.4383 102.618H86.7383C86.4182 102.618 86.1582 102.358 86.1582 102.038V101.338C86.1582 101.018 86.4182 100.758 86.7383 100.758H87.4383C87.7584 100.758 88.0184 101.018 88.0184 101.338V102.038C88.0184 102.338 87.7584 102.618 87.4383 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M90.7782 10.8299H90.0781C89.7581 10.8299 89.498 10.5699 89.498 10.2498V9.54976C89.498 9.22973 89.7581 8.96973 90.0781 8.96973H90.7782C91.0982 8.96973 91.3582 9.22973 91.3582 9.54976V10.2498C91.3782 10.5699 91.0982 10.8299 90.7782 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M90.7782 15.5503H90.0781C89.7581 15.5503 89.498 15.2903 89.498 14.9703V14.2702C89.498 13.9502 89.7581 13.6902 90.0781 13.6902H90.7782C91.0982 13.6902 91.3582 13.9502 91.3582 14.2702V14.9703C91.3782 15.2703 91.0982 15.5503 90.7782 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M90.7782 20.2508H90.0781C89.7581 20.2508 89.498 19.9908 89.498 19.6707V18.9707C89.498 18.6507 89.7581 18.3906 90.0781 18.3906H90.7782C91.0982 18.3906 91.3582 18.6507 91.3582 18.9707V19.6707C91.3782 19.9908 91.0982 20.2508 90.7782 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M90.7782 24.9512H90.0781C89.7581 24.9512 89.498 24.6912 89.498 24.3712V23.6711C89.498 23.3511 89.7581 23.0911 90.0781 23.0911H90.7782C91.0982 23.0911 91.3582 23.3511 91.3582 23.6711V24.3712C91.3782 24.6912 91.0982 24.9512 90.7782 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M90.7782 29.6717H90.0781C89.7581 29.6717 89.498 29.4117 89.498 29.0916V28.3916C89.498 28.0716 89.7581 27.8115 90.0781 27.8115H90.7782C91.0982 27.8115 91.3582 28.0716 91.3582 28.3916V29.0916C91.3782 29.4117 91.0982 29.6717 90.7782 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M90.7782 34.3721H90.0781C89.7581 34.3721 89.498 34.1121 89.498 33.7921V33.092C89.498 32.772 89.7581 32.512 90.0781 32.512H90.7782C91.0982 32.512 91.3582 32.772 91.3582 33.092V33.7921C91.3782 34.1121 91.0982 34.3721 90.7782 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M90.7782 39.0925H90.0781C89.7581 39.0925 89.498 38.8325 89.498 38.5124V37.8124C89.498 37.4923 89.7581 37.2323 90.0781 37.2323H90.7782C91.0982 37.2323 91.3582 37.4923 91.3582 37.8124V38.5124C91.3782 38.8125 91.0982 39.0925 90.7782 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M90.7782 43.7929H90.0781C89.7581 43.7929 89.498 43.5329 89.498 43.2129V42.5128C89.498 42.1928 89.7581 41.9327 90.0781 41.9327H90.7782C91.0982 41.9327 91.3582 42.1928 91.3582 42.5128V43.2129C91.3782 43.5329 91.0982 43.7929 90.7782 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M90.7782 48.4933H90.0781C89.7581 48.4933 89.498 48.2333 89.498 47.9133V47.2132C89.498 46.8932 89.7581 46.6332 90.0781 46.6332H90.7782C91.0982 46.6332 91.3582 46.8932 91.3582 47.2132V47.9133C91.3782 48.2333 91.0982 48.4933 90.7782 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M90.7782 53.2138H90.0781C89.7581 53.2138 89.498 52.9538 89.498 52.6338V51.9337C89.498 51.6137 89.7581 51.3536 90.0781 51.3536H90.7782C91.0982 51.3536 91.3582 51.6137 91.3582 51.9337V52.6338C91.3782 52.9538 91.0982 53.2138 90.7782 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M90.7782 57.9143H90.0781C89.7581 57.9143 89.498 57.6543 89.498 57.3342V56.6342C89.498 56.3141 89.7581 56.0541 90.0781 56.0541H90.7782C91.0982 56.0541 91.3582 56.3141 91.3582 56.6342V57.3342C91.3782 57.6543 91.0982 57.9143 90.7782 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M90.7782 62.6347H90.0781C89.7581 62.6347 89.498 62.3747 89.498 62.0546V61.3546C89.498 61.0345 89.7581 60.7745 90.0781 60.7745H90.7782C91.0982 60.7745 91.3582 61.0345 91.3582 61.3546V62.0546C91.3782 62.3547 91.0982 62.6347 90.7782 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M90.7782 67.3352H90.0781C89.7581 67.3352 89.498 67.0751 89.498 66.7551V66.055C89.498 65.735 89.7581 65.475 90.0781 65.475H90.7782C91.0982 65.475 91.3582 65.735 91.3582 66.055V66.7551C91.3782 67.0751 91.0982 67.3352 90.7782 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M90.7782 72.0356H90.0781C89.7581 72.0356 89.498 71.7755 89.498 71.4555V70.7554C89.498 70.4354 89.7581 70.1754 90.0781 70.1754H90.7782C91.0982 70.1754 91.3582 70.4354 91.3582 70.7554V71.4555C91.3782 71.7755 91.0982 72.0356 90.7782 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M90.7782 76.7559H90.0781C89.7581 76.7559 89.498 76.4959 89.498 76.1759V75.4758C89.498 75.1558 89.7581 74.8958 90.0781 74.8958H90.7782C91.0982 74.8958 91.3582 75.1558 91.3582 75.4758V76.1759C91.3782 76.4759 91.0982 76.7559 90.7782 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M90.7782 81.4564H90.0781C89.7581 81.4564 89.498 81.1964 89.498 80.8763V80.1763C89.498 79.8562 89.7581 79.5962 90.0781 79.5962H90.7782C91.0982 79.5962 91.3582 79.8562 91.3582 80.1763V80.8763C91.3782 81.1964 91.0982 81.4564 90.7782 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M90.7782 86.1568H90.0781C89.7581 86.1568 89.498 85.8968 89.498 85.5768V84.8767C89.498 84.5567 89.7581 84.2966 90.0781 84.2966H90.7782C91.0982 84.2966 91.3582 84.5567 91.3582 84.8767V85.5768C91.3782 85.8968 91.0982 86.1568 90.7782 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M90.7782 90.8773H90.0781C89.7581 90.8773 89.498 90.6172 89.498 90.2972V89.5971C89.498 89.2771 89.7581 89.0171 90.0781 89.0171H90.7782C91.0982 89.0171 91.3582 89.2771 91.3582 89.5971V90.2972C91.3782 90.6172 91.0982 90.8773 90.7782 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M90.7782 95.5777H90.0781C89.7581 95.5777 89.498 95.3177 89.498 94.9976V94.2976C89.498 93.9775 89.7581 93.7175 90.0781 93.7175H90.7782C91.0982 93.7175 91.3582 93.9775 91.3582 94.2976V94.9976C91.3782 95.3177 91.0982 95.5777 90.7782 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M90.7782 100.298H90.0781C89.7581 100.298 89.498 100.038 89.498 99.7181V99.018C89.498 98.698 89.7581 98.438 90.0781 98.438H90.7782C91.0982 98.438 91.3582 98.698 91.3582 99.018V99.7181C91.3782 100.018 91.0982 100.298 90.7782 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M94.2586 13.1501H93.5586C93.2385 13.1501 92.9785 12.8901 92.9785 12.57V11.87C92.9785 11.5499 93.2385 11.2899 93.5586 11.2899H94.2586C94.5787 11.2899 94.8387 11.5499 94.8387 11.87V12.57C94.8387 12.8901 94.5787 13.1501 94.2586 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M94.2586 17.8505H93.5586C93.2385 17.8505 92.9785 17.5905 92.9785 17.2705V16.5704C92.9785 16.2504 93.2385 15.9904 93.5586 15.9904H94.2586C94.5787 15.9904 94.8387 16.2504 94.8387 16.5704V17.2705C94.8387 17.5905 94.5787 17.8505 94.2586 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M94.2586 22.571H93.5586C93.2385 22.571 92.9785 22.311 92.9785 21.9909V21.2909C92.9785 20.9708 93.2385 20.7108 93.5586 20.7108H94.2586C94.5787 20.7108 94.8387 20.9708 94.8387 21.2909V21.9909C94.8387 22.311 94.5787 22.571 94.2586 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M94.2586 27.2714H93.5586C93.2385 27.2714 92.9785 27.0114 92.9785 26.6914V25.9913C92.9785 25.6713 93.2385 25.4113 93.5586 25.4113H94.2586C94.5787 25.4113 94.8387 25.6713 94.8387 25.9913V26.6914C94.8387 27.0114 94.5787 27.2714 94.2586 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M94.2586 31.9919H93.5586C93.2385 31.9919 92.9785 31.7319 92.9785 31.4118V30.7118C92.9785 30.3917 93.2385 30.1317 93.5586 30.1317H94.2586C94.5787 30.1317 94.8387 30.3917 94.8387 30.7118V31.4118C94.8387 31.7119 94.5787 31.9919 94.2586 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M94.2586 36.6923H93.5586C93.2385 36.6923 92.9785 36.4323 92.9785 36.1123V35.4122C92.9785 35.0922 93.2385 34.8322 93.5586 34.8322H94.2586C94.5787 34.8322 94.8387 35.0922 94.8387 35.4122V36.1123C94.8387 36.4323 94.5787 36.6923 94.2586 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M94.2586 41.3928H93.5586C93.2385 41.3928 92.9785 41.1327 92.9785 40.8127V40.1127C92.9785 39.7926 93.2385 39.5326 93.5586 39.5326H94.2586C94.5787 39.5326 94.8387 39.7926 94.8387 40.1127V40.8127C94.8387 41.1327 94.5787 41.3928 94.2586 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M94.2586 46.1131H93.5586C93.2385 46.1131 92.9785 45.8531 92.9785 45.5331V44.833C92.9785 44.513 93.2385 44.2529 93.5586 44.2529H94.2586C94.5787 44.2529 94.8387 44.513 94.8387 44.833V45.5331C94.8387 45.8531 94.5787 46.1131 94.2586 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M94.2586 50.8136H93.5586C93.2385 50.8136 92.9785 50.5535 92.9785 50.2335V49.5335C92.9785 49.2134 93.2385 48.9534 93.5586 48.9534H94.2586C94.5787 48.9534 94.8387 49.2134 94.8387 49.5335V50.2335C94.8387 50.5535 94.5787 50.8136 94.2586 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M94.2586 55.534H93.5586C93.2385 55.534 92.9785 55.274 92.9785 54.9539V54.2539C92.9785 53.9338 93.2385 53.6738 93.5586 53.6738H94.2586C94.5787 53.6738 94.8387 53.9338 94.8387 54.2539V54.9539C94.8387 55.254 94.5787 55.534 94.2586 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M94.2586 60.2344H93.5586C93.2385 60.2344 92.9785 59.9744 92.9785 59.6544V58.9543C92.9785 58.6343 93.2385 58.3743 93.5586 58.3743H94.2586C94.5787 58.3743 94.8387 58.6343 94.8387 58.9543V59.6544C94.8387 59.9744 94.5787 60.2344 94.2586 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M94.2586 64.9349H93.5586C93.2385 64.9349 92.9785 64.6748 92.9785 64.3548V63.6547C92.9785 63.3347 93.2385 63.0747 93.5586 63.0747H94.2586C94.5787 63.0747 94.8387 63.3347 94.8387 63.6547V64.3548C94.8387 64.6748 94.5787 64.9349 94.2586 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M94.2586 69.6553H93.5586C93.2385 69.6553 92.9785 69.3953 92.9785 69.0753V68.3752C92.9785 68.0552 93.2385 67.7952 93.5586 67.7952H94.2586C94.5787 67.7952 94.8387 68.0552 94.8387 68.3752V69.0753C94.8387 69.3953 94.5787 69.6553 94.2586 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M94.2586 74.3558H93.5586C93.2385 74.3558 92.9785 74.0958 92.9785 73.7758V73.0757C92.9785 72.7557 93.2385 72.4956 93.5586 72.4956H94.2586C94.5787 72.4956 94.8387 72.7557 94.8387 73.0757V73.7758C94.8387 74.0958 94.5787 74.3558 94.2586 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M94.2586 79.0762H93.5586C93.2385 79.0762 92.9785 78.8162 92.9785 78.4962V77.7961C92.9785 77.4761 93.2385 77.2161 93.5586 77.2161H94.2586C94.5787 77.2161 94.8387 77.4761 94.8387 77.7961V78.4962C94.8387 78.7962 94.5787 79.0762 94.2586 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M94.2586 83.7767H93.5586C93.2385 83.7767 92.9785 83.5166 92.9785 83.1966V82.4965C92.9785 82.1765 93.2385 81.9165 93.5586 81.9165H94.2586C94.5787 81.9165 94.8387 82.1765 94.8387 82.4965V83.1966C94.8387 83.5166 94.5787 83.7767 94.2586 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M94.2586 88.4771H93.5586C93.2385 88.4771 92.9785 88.2171 92.9785 87.897V87.197C92.9785 86.8769 93.2385 86.6169 93.5586 86.6169H94.2586C94.5787 86.6169 94.8387 86.8769 94.8387 87.197V87.897C94.8387 88.2171 94.5787 88.4771 94.2586 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M94.2586 93.1975H93.5586C93.2385 93.1975 92.9785 92.9375 92.9785 92.6175V91.9174C92.9785 91.5974 93.2385 91.3374 93.5586 91.3374H94.2586C94.5787 91.3374 94.8387 91.5974 94.8387 91.9174V92.6175C94.8387 92.9375 94.5787 93.1975 94.2586 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M94.2586 97.898H93.5586C93.2385 97.898 92.9785 97.638 92.9785 97.3179V96.6179C92.9785 96.2978 93.2385 96.0378 93.5586 96.0378H94.2586C94.5787 96.0378 94.8387 96.2978 94.8387 96.6179V97.3179C94.8387 97.638 94.5787 97.898 94.2586 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M94.2586 102.618H93.5586C93.2385 102.618 92.9785 102.358 92.9785 102.038V101.338C92.9785 101.018 93.2385 100.758 93.5586 100.758H94.2586C94.5787 100.758 94.8387 101.018 94.8387 101.338V102.038C94.8387 102.338 94.5787 102.618 94.2586 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M97.5985 10.8299H96.8984C96.5784 10.8299 96.3184 10.5699 96.3184 10.2498V9.54976C96.3184 9.22973 96.5784 8.96973 96.8984 8.96973H97.5985C97.9185 8.96973 98.1785 9.22973 98.1785 9.54976V10.2498C98.1785 10.5699 97.9185 10.8299 97.5985 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M97.5985 15.5503H96.8984C96.5784 15.5503 96.3184 15.2903 96.3184 14.9703V14.2702C96.3184 13.9502 96.5784 13.6902 96.8984 13.6902H97.5985C97.9185 13.6902 98.1785 13.9502 98.1785 14.2702V14.9703C98.1785 15.2703 97.9185 15.5503 97.5985 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M97.5985 20.2508H96.8984C96.5784 20.2508 96.3184 19.9908 96.3184 19.6707V18.9707C96.3184 18.6507 96.5784 18.3906 96.8984 18.3906H97.5985C97.9185 18.3906 98.1785 18.6507 98.1785 18.9707V19.6707C98.1785 19.9908 97.9185 20.2508 97.5985 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M97.5985 24.9512H96.8984C96.5784 24.9512 96.3184 24.6912 96.3184 24.3712V23.6711C96.3184 23.3511 96.5784 23.0911 96.8984 23.0911H97.5985C97.9185 23.0911 98.1785 23.3511 98.1785 23.6711V24.3712C98.1785 24.6912 97.9185 24.9512 97.5985 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M97.5985 29.6717H96.8984C96.5784 29.6717 96.3184 29.4117 96.3184 29.0916V28.3916C96.3184 28.0716 96.5784 27.8115 96.8984 27.8115H97.5985C97.9185 27.8115 98.1785 28.0716 98.1785 28.3916V29.0916C98.1785 29.4117 97.9185 29.6717 97.5985 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M97.5985 34.3721H96.8984C96.5784 34.3721 96.3184 34.1121 96.3184 33.7921V33.092C96.3184 32.772 96.5784 32.512 96.8984 32.512H97.5985C97.9185 32.512 98.1785 32.772 98.1785 33.092V33.7921C98.1785 34.1121 97.9185 34.3721 97.5985 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M97.5985 39.0925H96.8984C96.5784 39.0925 96.3184 38.8325 96.3184 38.5124V37.8124C96.3184 37.4923 96.5784 37.2323 96.8984 37.2323H97.5985C97.9185 37.2323 98.1785 37.4923 98.1785 37.8124V38.5124C98.1785 38.8125 97.9185 39.0925 97.5985 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M97.5985 43.7929H96.8984C96.5784 43.7929 96.3184 43.5329 96.3184 43.2129V42.5128C96.3184 42.1928 96.5784 41.9327 96.8984 41.9327H97.5985C97.9185 41.9327 98.1785 42.1928 98.1785 42.5128V43.2129C98.1785 43.5329 97.9185 43.7929 97.5985 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M97.5985 48.4933H96.8984C96.5784 48.4933 96.3184 48.2333 96.3184 47.9133V47.2132C96.3184 46.8932 96.5784 46.6332 96.8984 46.6332H97.5985C97.9185 46.6332 98.1785 46.8932 98.1785 47.2132V47.9133C98.1785 48.2333 97.9185 48.4933 97.5985 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M97.5985 53.2138H96.8984C96.5784 53.2138 96.3184 52.9538 96.3184 52.6338V51.9337C96.3184 51.6137 96.5784 51.3536 96.8984 51.3536H97.5985C97.9185 51.3536 98.1785 51.6137 98.1785 51.9337V52.6338C98.1785 52.9538 97.9185 53.2138 97.5985 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M97.5985 57.9143H96.8984C96.5784 57.9143 96.3184 57.6543 96.3184 57.3342V56.6342C96.3184 56.3141 96.5784 56.0541 96.8984 56.0541H97.5985C97.9185 56.0541 98.1785 56.3141 98.1785 56.6342V57.3342C98.1785 57.6543 97.9185 57.9143 97.5985 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M97.5985 62.6347H96.8984C96.5784 62.6347 96.3184 62.3747 96.3184 62.0546V61.3546C96.3184 61.0345 96.5784 60.7745 96.8984 60.7745H97.5985C97.9185 60.7745 98.1785 61.0345 98.1785 61.3546V62.0546C98.1785 62.3547 97.9185 62.6347 97.5985 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M97.5985 67.3352H96.8984C96.5784 67.3352 96.3184 67.0751 96.3184 66.7551V66.055C96.3184 65.735 96.5784 65.475 96.8984 65.475H97.5985C97.9185 65.475 98.1785 65.735 98.1785 66.055V66.7551C98.1785 67.0751 97.9185 67.3352 97.5985 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M97.5985 72.0356H96.8984C96.5784 72.0356 96.3184 71.7755 96.3184 71.4555V70.7554C96.3184 70.4354 96.5784 70.1754 96.8984 70.1754H97.5985C97.9185 70.1754 98.1785 70.4354 98.1785 70.7554V71.4555C98.1785 71.7755 97.9185 72.0356 97.5985 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M97.5985 76.7559H96.8984C96.5784 76.7559 96.3184 76.4959 96.3184 76.1759V75.4758C96.3184 75.1558 96.5784 74.8958 96.8984 74.8958H97.5985C97.9185 74.8958 98.1785 75.1558 98.1785 75.4758V76.1759C98.1785 76.4759 97.9185 76.7559 97.5985 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M97.5985 81.4564H96.8984C96.5784 81.4564 96.3184 81.1964 96.3184 80.8763V80.1763C96.3184 79.8562 96.5784 79.5962 96.8984 79.5962H97.5985C97.9185 79.5962 98.1785 79.8562 98.1785 80.1763V80.8763C98.1785 81.1964 97.9185 81.4564 97.5985 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M97.5985 86.1568H96.8984C96.5784 86.1568 96.3184 85.8968 96.3184 85.5768V84.8767C96.3184 84.5567 96.5784 84.2966 96.8984 84.2966H97.5985C97.9185 84.2966 98.1785 84.5567 98.1785 84.8767V85.5768C98.1785 85.8968 97.9185 86.1568 97.5985 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M97.5985 90.8773H96.8984C96.5784 90.8773 96.3184 90.6172 96.3184 90.2972V89.5971C96.3184 89.2771 96.5784 89.0171 96.8984 89.0171H97.5985C97.9185 89.0171 98.1785 89.2771 98.1785 89.5971V90.2972C98.1785 90.6172 97.9185 90.8773 97.5985 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M97.5985 95.5777H96.8984C96.5784 95.5777 96.3184 95.3177 96.3184 94.9976V94.2976C96.3184 93.9775 96.5784 93.7175 96.8984 93.7175H97.5985C97.9185 93.7175 98.1785 93.9775 98.1785 94.2976V94.9976C98.1785 95.3177 97.9185 95.5777 97.5985 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M97.5985 100.298H96.8984C96.5784 100.298 96.3184 100.038 96.3184 99.7181V99.018C96.3184 98.698 96.5784 98.438 96.8984 98.438H97.5985C97.9185 98.438 98.1785 98.698 98.1785 99.018V99.7181C98.1785 100.018 97.9185 100.298 97.5985 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M101.079 13.1501H100.379C100.059 13.1501 99.7988 12.8901 99.7988 12.57V11.87C99.7988 11.5499 100.059 11.2899 100.379 11.2899H101.079C101.399 11.2899 101.659 11.5499 101.659 11.87V12.57C101.659 12.8901 101.399 13.1501 101.079 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M101.079 17.8505H100.379C100.059 17.8505 99.7988 17.5905 99.7988 17.2705V16.5704C99.7988 16.2504 100.059 15.9904 100.379 15.9904H101.079C101.399 15.9904 101.659 16.2504 101.659 16.5704V17.2705C101.659 17.5905 101.399 17.8505 101.079 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M101.079 22.571H100.379C100.059 22.571 99.7988 22.311 99.7988 21.9909V21.2909C99.7988 20.9708 100.059 20.7108 100.379 20.7108H101.079C101.399 20.7108 101.659 20.9708 101.659 21.2909V21.9909C101.659 22.311 101.399 22.571 101.079 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M101.079 27.2714H100.379C100.059 27.2714 99.7988 27.0114 99.7988 26.6914V25.9913C99.7988 25.6713 100.059 25.4113 100.379 25.4113H101.079C101.399 25.4113 101.659 25.6713 101.659 25.9913V26.6914C101.659 27.0114 101.399 27.2714 101.079 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M101.079 31.9919H100.379C100.059 31.9919 99.7988 31.7319 99.7988 31.4118V30.7118C99.7988 30.3917 100.059 30.1317 100.379 30.1317H101.079C101.399 30.1317 101.659 30.3917 101.659 30.7118V31.4118C101.659 31.7119 101.399 31.9919 101.079 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M101.079 36.6923H100.379C100.059 36.6923 99.7988 36.4323 99.7988 36.1123V35.4122C99.7988 35.0922 100.059 34.8322 100.379 34.8322H101.079C101.399 34.8322 101.659 35.0922 101.659 35.4122V36.1123C101.659 36.4323 101.399 36.6923 101.079 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M101.079 41.3928H100.379C100.059 41.3928 99.7988 41.1327 99.7988 40.8127V40.1127C99.7988 39.7926 100.059 39.5326 100.379 39.5326H101.079C101.399 39.5326 101.659 39.7926 101.659 40.1127V40.8127C101.659 41.1327 101.399 41.3928 101.079 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M101.079 46.1131H100.379C100.059 46.1131 99.7988 45.8531 99.7988 45.5331V44.833C99.7988 44.513 100.059 44.2529 100.379 44.2529H101.079C101.399 44.2529 101.659 44.513 101.659 44.833V45.5331C101.659 45.8531 101.399 46.1131 101.079 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M101.079 50.8136H100.379C100.059 50.8136 99.7988 50.5535 99.7988 50.2335V49.5335C99.7988 49.2134 100.059 48.9534 100.379 48.9534H101.079C101.399 48.9534 101.659 49.2134 101.659 49.5335V50.2335C101.659 50.5535 101.399 50.8136 101.079 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M101.079 55.534H100.379C100.059 55.534 99.7988 55.274 99.7988 54.9539V54.2539C99.7988 53.9338 100.059 53.6738 100.379 53.6738H101.079C101.399 53.6738 101.659 53.9338 101.659 54.2539V54.9539C101.659 55.254 101.399 55.534 101.079 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M101.079 60.2344H100.379C100.059 60.2344 99.7988 59.9744 99.7988 59.6544V58.9543C99.7988 58.6343 100.059 58.3743 100.379 58.3743H101.079C101.399 58.3743 101.659 58.6343 101.659 58.9543V59.6544C101.659 59.9744 101.399 60.2344 101.079 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M101.079 64.9349H100.379C100.059 64.9349 99.7988 64.6748 99.7988 64.3548V63.6547C99.7988 63.3347 100.059 63.0747 100.379 63.0747H101.079C101.399 63.0747 101.659 63.3347 101.659 63.6547V64.3548C101.659 64.6748 101.399 64.9349 101.079 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M101.079 69.6553H100.379C100.059 69.6553 99.7988 69.3953 99.7988 69.0753V68.3752C99.7988 68.0552 100.059 67.7952 100.379 67.7952H101.079C101.399 67.7952 101.659 68.0552 101.659 68.3752V69.0753C101.659 69.3953 101.399 69.6553 101.079 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M101.079 74.3558H100.379C100.059 74.3558 99.7988 74.0958 99.7988 73.7758V73.0757C99.7988 72.7557 100.059 72.4956 100.379 72.4956H101.079C101.399 72.4956 101.659 72.7557 101.659 73.0757V73.7758C101.659 74.0958 101.399 74.3558 101.079 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M101.079 79.0762H100.379C100.059 79.0762 99.7988 78.8162 99.7988 78.4962V77.7961C99.7988 77.4761 100.059 77.2161 100.379 77.2161H101.079C101.399 77.2161 101.659 77.4761 101.659 77.7961V78.4962C101.659 78.7962 101.399 79.0762 101.079 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M101.079 83.7767H100.379C100.059 83.7767 99.7988 83.5166 99.7988 83.1966V82.4965C99.7988 82.1765 100.059 81.9165 100.379 81.9165H101.079C101.399 81.9165 101.659 82.1765 101.659 82.4965V83.1966C101.659 83.5166 101.399 83.7767 101.079 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M101.079 88.4771H100.379C100.059 88.4771 99.7988 88.2171 99.7988 87.897V87.197C99.7988 86.8769 100.059 86.6169 100.379 86.6169H101.079C101.399 86.6169 101.659 86.8769 101.659 87.197V87.897C101.659 88.2171 101.399 88.4771 101.079 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M101.079 93.1975H100.379C100.059 93.1975 99.7988 92.9375 99.7988 92.6175V91.9174C99.7988 91.5974 100.059 91.3374 100.379 91.3374H101.079C101.399 91.3374 101.659 91.5974 101.659 91.9174V92.6175C101.659 92.9375 101.399 93.1975 101.079 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M101.079 97.898H100.379C100.059 97.898 99.7988 97.638 99.7988 97.3179V96.6179C99.7988 96.2978 100.059 96.0378 100.379 96.0378H101.079C101.399 96.0378 101.659 96.2978 101.659 96.6179V97.3179C101.659 97.638 101.399 97.898 101.079 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M101.079 102.618H100.379C100.059 102.618 99.7988 102.358 99.7988 102.038V101.338C99.7988 101.018 100.059 100.758 100.379 100.758H101.079C101.399 100.758 101.659 101.018 101.659 101.338V102.038C101.659 102.338 101.399 102.618 101.079 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M104.419 10.8299H103.719C103.399 10.8299 103.139 10.5699 103.139 10.2498V9.54976C103.139 9.22973 103.399 8.96973 103.719 8.96973H104.419C104.739 8.96973 104.999 9.22973 104.999 9.54976V10.2498C104.999 10.5699 104.739 10.8299 104.419 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M104.419 15.5503H103.719C103.399 15.5503 103.139 15.2903 103.139 14.9703V14.2702C103.139 13.9502 103.399 13.6902 103.719 13.6902H104.419C104.739 13.6902 104.999 13.9502 104.999 14.2702V14.9703C104.999 15.2703 104.739 15.5503 104.419 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M104.419 20.2508H103.719C103.399 20.2508 103.139 19.9908 103.139 19.6707V18.9707C103.139 18.6507 103.399 18.3906 103.719 18.3906H104.419C104.739 18.3906 104.999 18.6507 104.999 18.9707V19.6707C104.999 19.9908 104.739 20.2508 104.419 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M104.419 24.9512H103.719C103.399 24.9512 103.139 24.6912 103.139 24.3712V23.6711C103.139 23.3511 103.399 23.0911 103.719 23.0911H104.419C104.739 23.0911 104.999 23.3511 104.999 23.6711V24.3712C104.999 24.6912 104.739 24.9512 104.419 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M104.419 29.6717H103.719C103.399 29.6717 103.139 29.4117 103.139 29.0916V28.3916C103.139 28.0716 103.399 27.8115 103.719 27.8115H104.419C104.739 27.8115 104.999 28.0716 104.999 28.3916V29.0916C104.999 29.4117 104.739 29.6717 104.419 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M104.419 34.3721H103.719C103.399 34.3721 103.139 34.1121 103.139 33.7921V33.092C103.139 32.772 103.399 32.512 103.719 32.512H104.419C104.739 32.512 104.999 32.772 104.999 33.092V33.7921C104.999 34.1121 104.739 34.3721 104.419 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M104.419 39.0925H103.719C103.399 39.0925 103.139 38.8325 103.139 38.5124V37.8124C103.139 37.4923 103.399 37.2323 103.719 37.2323H104.419C104.739 37.2323 104.999 37.4923 104.999 37.8124V38.5124C104.999 38.8125 104.739 39.0925 104.419 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M104.419 43.7929H103.719C103.399 43.7929 103.139 43.5329 103.139 43.2129V42.5128C103.139 42.1928 103.399 41.9327 103.719 41.9327H104.419C104.739 41.9327 104.999 42.1928 104.999 42.5128V43.2129C104.999 43.5329 104.739 43.7929 104.419 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M104.419 48.4933H103.719C103.399 48.4933 103.139 48.2333 103.139 47.9133V47.2132C103.139 46.8932 103.399 46.6332 103.719 46.6332H104.419C104.739 46.6332 104.999 46.8932 104.999 47.2132V47.9133C104.999 48.2333 104.739 48.4933 104.419 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M104.419 53.2138H103.719C103.399 53.2138 103.139 52.9538 103.139 52.6338V51.9337C103.139 51.6137 103.399 51.3536 103.719 51.3536H104.419C104.739 51.3536 104.999 51.6137 104.999 51.9337V52.6338C104.999 52.9538 104.739 53.2138 104.419 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M104.419 57.9143H103.719C103.399 57.9143 103.139 57.6543 103.139 57.3342V56.6342C103.139 56.3141 103.399 56.0541 103.719 56.0541H104.419C104.739 56.0541 104.999 56.3141 104.999 56.6342V57.3342C104.999 57.6543 104.739 57.9143 104.419 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M104.419 62.6347H103.719C103.399 62.6347 103.139 62.3747 103.139 62.0546V61.3546C103.139 61.0345 103.399 60.7745 103.719 60.7745H104.419C104.739 60.7745 104.999 61.0345 104.999 61.3546V62.0546C104.999 62.3547 104.739 62.6347 104.419 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M104.419 67.3352H103.719C103.399 67.3352 103.139 67.0751 103.139 66.7551V66.055C103.139 65.735 103.399 65.475 103.719 65.475H104.419C104.739 65.475 104.999 65.735 104.999 66.055V66.7551C104.999 67.0751 104.739 67.3352 104.419 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M104.419 72.0356H103.719C103.399 72.0356 103.139 71.7755 103.139 71.4555V70.7554C103.139 70.4354 103.399 70.1754 103.719 70.1754H104.419C104.739 70.1754 104.999 70.4354 104.999 70.7554V71.4555C104.999 71.7755 104.739 72.0356 104.419 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M104.419 76.7559H103.719C103.399 76.7559 103.139 76.4959 103.139 76.1759V75.4758C103.139 75.1558 103.399 74.8958 103.719 74.8958H104.419C104.739 74.8958 104.999 75.1558 104.999 75.4758V76.1759C104.999 76.4759 104.739 76.7559 104.419 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M104.419 81.4564H103.719C103.399 81.4564 103.139 81.1964 103.139 80.8763V80.1763C103.139 79.8562 103.399 79.5962 103.719 79.5962H104.419C104.739 79.5962 104.999 79.8562 104.999 80.1763V80.8763C104.999 81.1964 104.739 81.4564 104.419 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M104.419 86.1568H103.719C103.399 86.1568 103.139 85.8968 103.139 85.5768V84.8767C103.139 84.5567 103.399 84.2966 103.719 84.2966H104.419C104.739 84.2966 104.999 84.5567 104.999 84.8767V85.5768C104.999 85.8968 104.739 86.1568 104.419 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M104.419 90.8773H103.719C103.399 90.8773 103.139 90.6172 103.139 90.2972V89.5971C103.139 89.2771 103.399 89.0171 103.719 89.0171H104.419C104.739 89.0171 104.999 89.2771 104.999 89.5971V90.2972C104.999 90.6172 104.739 90.8773 104.419 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M104.419 95.5777H103.719C103.399 95.5777 103.139 95.3177 103.139 94.9976V94.2976C103.139 93.9775 103.399 93.7175 103.719 93.7175H104.419C104.739 93.7175 104.999 93.9775 104.999 94.2976V94.9976C104.999 95.3177 104.739 95.5777 104.419 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M104.419 100.298H103.719C103.399 100.298 103.139 100.038 103.139 99.7181V99.018C103.139 98.698 103.399 98.438 103.719 98.438H104.419C104.739 98.438 104.999 98.698 104.999 99.018V99.7181C104.999 100.018 104.739 100.298 104.419 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M107.899 13.1501H107.199C106.879 13.1501 106.619 12.8901 106.619 12.57V11.87C106.619 11.5499 106.879 11.2899 107.199 11.2899H107.899C108.219 11.2899 108.479 11.5499 108.479 11.87V12.57C108.479 12.8901 108.219 13.1501 107.899 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M107.899 17.8505H107.199C106.879 17.8505 106.619 17.5905 106.619 17.2705V16.5704C106.619 16.2504 106.879 15.9904 107.199 15.9904H107.899C108.219 15.9904 108.479 16.2504 108.479 16.5704V17.2705C108.479 17.5905 108.219 17.8505 107.899 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M107.899 22.571H107.199C106.879 22.571 106.619 22.311 106.619 21.9909V21.2909C106.619 20.9708 106.879 20.7108 107.199 20.7108H107.899C108.219 20.7108 108.479 20.9708 108.479 21.2909V21.9909C108.479 22.311 108.219 22.571 107.899 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M107.899 27.2714H107.199C106.879 27.2714 106.619 27.0114 106.619 26.6914V25.9913C106.619 25.6713 106.879 25.4113 107.199 25.4113H107.899C108.219 25.4113 108.479 25.6713 108.479 25.9913V26.6914C108.479 27.0114 108.219 27.2714 107.899 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M107.899 31.9919H107.199C106.879 31.9919 106.619 31.7319 106.619 31.4118V30.7118C106.619 30.3917 106.879 30.1317 107.199 30.1317H107.899C108.219 30.1317 108.479 30.3917 108.479 30.7118V31.4118C108.479 31.7119 108.219 31.9919 107.899 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M107.899 36.6923H107.199C106.879 36.6923 106.619 36.4323 106.619 36.1123V35.4122C106.619 35.0922 106.879 34.8322 107.199 34.8322H107.899C108.219 34.8322 108.479 35.0922 108.479 35.4122V36.1123C108.479 36.4323 108.219 36.6923 107.899 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M107.899 41.3928H107.199C106.879 41.3928 106.619 41.1327 106.619 40.8127V40.1127C106.619 39.7926 106.879 39.5326 107.199 39.5326H107.899C108.219 39.5326 108.479 39.7926 108.479 40.1127V40.8127C108.479 41.1327 108.219 41.3928 107.899 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M107.899 46.1131H107.199C106.879 46.1131 106.619 45.8531 106.619 45.5331V44.833C106.619 44.513 106.879 44.2529 107.199 44.2529H107.899C108.219 44.2529 108.479 44.513 108.479 44.833V45.5331C108.479 45.8531 108.219 46.1131 107.899 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M107.899 50.8136H107.199C106.879 50.8136 106.619 50.5535 106.619 50.2335V49.5335C106.619 49.2134 106.879 48.9534 107.199 48.9534H107.899C108.219 48.9534 108.479 49.2134 108.479 49.5335V50.2335C108.479 50.5535 108.219 50.8136 107.899 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M107.899 55.534H107.199C106.879 55.534 106.619 55.274 106.619 54.9539V54.2539C106.619 53.9338 106.879 53.6738 107.199 53.6738H107.899C108.219 53.6738 108.479 53.9338 108.479 54.2539V54.9539C108.479 55.254 108.219 55.534 107.899 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M107.899 60.2344H107.199C106.879 60.2344 106.619 59.9744 106.619 59.6544V58.9543C106.619 58.6343 106.879 58.3743 107.199 58.3743H107.899C108.219 58.3743 108.479 58.6343 108.479 58.9543V59.6544C108.479 59.9744 108.219 60.2344 107.899 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M107.899 64.9349H107.199C106.879 64.9349 106.619 64.6748 106.619 64.3548V63.6547C106.619 63.3347 106.879 63.0747 107.199 63.0747H107.899C108.219 63.0747 108.479 63.3347 108.479 63.6547V64.3548C108.479 64.6748 108.219 64.9349 107.899 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M107.899 69.6553H107.199C106.879 69.6553 106.619 69.3953 106.619 69.0753V68.3752C106.619 68.0552 106.879 67.7952 107.199 67.7952H107.899C108.219 67.7952 108.479 68.0552 108.479 68.3752V69.0753C108.479 69.3953 108.219 69.6553 107.899 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M107.899 74.3558H107.199C106.879 74.3558 106.619 74.0958 106.619 73.7758V73.0757C106.619 72.7557 106.879 72.4956 107.199 72.4956H107.899C108.219 72.4956 108.479 72.7557 108.479 73.0757V73.7758C108.479 74.0958 108.219 74.3558 107.899 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M107.899 79.0762H107.199C106.879 79.0762 106.619 78.8162 106.619 78.4962V77.7961C106.619 77.4761 106.879 77.2161 107.199 77.2161H107.899C108.219 77.2161 108.479 77.4761 108.479 77.7961V78.4962C108.479 78.7962 108.219 79.0762 107.899 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M107.899 83.7767H107.199C106.879 83.7767 106.619 83.5166 106.619 83.1966V82.4965C106.619 82.1765 106.879 81.9165 107.199 81.9165H107.899C108.219 81.9165 108.479 82.1765 108.479 82.4965V83.1966C108.479 83.5166 108.219 83.7767 107.899 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M107.899 88.4771H107.199C106.879 88.4771 106.619 88.2171 106.619 87.897V87.197C106.619 86.8769 106.879 86.6169 107.199 86.6169H107.899C108.219 86.6169 108.479 86.8769 108.479 87.197V87.897C108.479 88.2171 108.219 88.4771 107.899 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M107.899 93.1975H107.199C106.879 93.1975 106.619 92.9375 106.619 92.6175V91.9174C106.619 91.5974 106.879 91.3374 107.199 91.3374H107.899C108.219 91.3374 108.479 91.5974 108.479 91.9174V92.6175C108.479 92.9375 108.219 93.1975 107.899 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M107.899 97.898H107.199C106.879 97.898 106.619 97.638 106.619 97.3179V96.6179C106.619 96.2978 106.879 96.0378 107.199 96.0378H107.899C108.219 96.0378 108.479 96.2978 108.479 96.6179V97.3179C108.479 97.638 108.219 97.898 107.899 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M107.899 102.618H107.199C106.879 102.618 106.619 102.358 106.619 102.038V101.338C106.619 101.018 106.879 100.758 107.199 100.758H107.899C108.219 100.758 108.479 101.018 108.479 101.338V102.038C108.479 102.338 108.219 102.618 107.899 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M111.241 10.8299H110.541C110.221 10.8299 109.961 10.5699 109.961 10.2498V9.54976C109.961 9.22973 110.221 8.96973 110.541 8.96973H111.241C111.561 8.96973 111.821 9.22973 111.821 9.54976V10.2498C111.821 10.5699 111.561 10.8299 111.241 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M111.241 15.5503H110.541C110.221 15.5503 109.961 15.2903 109.961 14.9703V14.2702C109.961 13.9502 110.221 13.6902 110.541 13.6902H111.241C111.561 13.6902 111.821 13.9502 111.821 14.2702V14.9703C111.821 15.2703 111.561 15.5503 111.241 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M111.241 20.2508H110.541C110.221 20.2508 109.961 19.9908 109.961 19.6707V18.9707C109.961 18.6507 110.221 18.3906 110.541 18.3906H111.241C111.561 18.3906 111.821 18.6507 111.821 18.9707V19.6707C111.821 19.9908 111.561 20.2508 111.241 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M111.241 24.9512H110.541C110.221 24.9512 109.961 24.6912 109.961 24.3712V23.6711C109.961 23.3511 110.221 23.0911 110.541 23.0911H111.241C111.561 23.0911 111.821 23.3511 111.821 23.6711V24.3712C111.821 24.6912 111.561 24.9512 111.241 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M111.241 29.6717H110.541C110.221 29.6717 109.961 29.4117 109.961 29.0916V28.3916C109.961 28.0716 110.221 27.8115 110.541 27.8115H111.241C111.561 27.8115 111.821 28.0716 111.821 28.3916V29.0916C111.821 29.4117 111.561 29.6717 111.241 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M111.241 34.3721H110.541C110.221 34.3721 109.961 34.1121 109.961 33.7921V33.092C109.961 32.772 110.221 32.512 110.541 32.512H111.241C111.561 32.512 111.821 32.772 111.821 33.092V33.7921C111.821 34.1121 111.561 34.3721 111.241 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M111.241 39.0925H110.541C110.221 39.0925 109.961 38.8325 109.961 38.5124V37.8124C109.961 37.4923 110.221 37.2323 110.541 37.2323H111.241C111.561 37.2323 111.821 37.4923 111.821 37.8124V38.5124C111.821 38.8125 111.561 39.0925 111.241 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M111.241 43.7929H110.541C110.221 43.7929 109.961 43.5329 109.961 43.2129V42.5128C109.961 42.1928 110.221 41.9327 110.541 41.9327H111.241C111.561 41.9327 111.821 42.1928 111.821 42.5128V43.2129C111.821 43.5329 111.561 43.7929 111.241 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M111.241 48.4933H110.541C110.221 48.4933 109.961 48.2333 109.961 47.9133V47.2132C109.961 46.8932 110.221 46.6332 110.541 46.6332H111.241C111.561 46.6332 111.821 46.8932 111.821 47.2132V47.9133C111.821 48.2333 111.561 48.4933 111.241 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M111.241 53.2138H110.541C110.221 53.2138 109.961 52.9538 109.961 52.6338V51.9337C109.961 51.6137 110.221 51.3536 110.541 51.3536H111.241C111.561 51.3536 111.821 51.6137 111.821 51.9337V52.6338C111.821 52.9538 111.561 53.2138 111.241 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M111.241 57.9143H110.541C110.221 57.9143 109.961 57.6543 109.961 57.3342V56.6342C109.961 56.3141 110.221 56.0541 110.541 56.0541H111.241C111.561 56.0541 111.821 56.3141 111.821 56.6342V57.3342C111.821 57.6543 111.561 57.9143 111.241 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M111.241 62.6347H110.541C110.221 62.6347 109.961 62.3747 109.961 62.0546V61.3546C109.961 61.0345 110.221 60.7745 110.541 60.7745H111.241C111.561 60.7745 111.821 61.0345 111.821 61.3546V62.0546C111.821 62.3547 111.561 62.6347 111.241 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M111.241 67.3352H110.541C110.221 67.3352 109.961 67.0751 109.961 66.7551V66.055C109.961 65.735 110.221 65.475 110.541 65.475H111.241C111.561 65.475 111.821 65.735 111.821 66.055V66.7551C111.821 67.0751 111.561 67.3352 111.241 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M111.241 72.0356H110.541C110.221 72.0356 109.961 71.7755 109.961 71.4555V70.7554C109.961 70.4354 110.221 70.1754 110.541 70.1754H111.241C111.561 70.1754 111.821 70.4354 111.821 70.7554V71.4555C111.821 71.7755 111.561 72.0356 111.241 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M111.241 76.7559H110.541C110.221 76.7559 109.961 76.4959 109.961 76.1759V75.4758C109.961 75.1558 110.221 74.8958 110.541 74.8958H111.241C111.561 74.8958 111.821 75.1558 111.821 75.4758V76.1759C111.821 76.4759 111.561 76.7559 111.241 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M111.241 81.4564H110.541C110.221 81.4564 109.961 81.1964 109.961 80.8763V80.1763C109.961 79.8562 110.221 79.5962 110.541 79.5962H111.241C111.561 79.5962 111.821 79.8562 111.821 80.1763V80.8763C111.821 81.1964 111.561 81.4564 111.241 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M111.241 86.1568H110.541C110.221 86.1568 109.961 85.8968 109.961 85.5768V84.8767C109.961 84.5567 110.221 84.2966 110.541 84.2966H111.241C111.561 84.2966 111.821 84.5567 111.821 84.8767V85.5768C111.821 85.8968 111.561 86.1568 111.241 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M111.241 90.8773H110.541C110.221 90.8773 109.961 90.6172 109.961 90.2972V89.5971C109.961 89.2771 110.221 89.0171 110.541 89.0171H111.241C111.561 89.0171 111.821 89.2771 111.821 89.5971V90.2972C111.821 90.6172 111.561 90.8773 111.241 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M111.241 95.5777H110.541C110.221 95.5777 109.961 95.3177 109.961 94.9976V94.2976C109.961 93.9775 110.221 93.7175 110.541 93.7175H111.241C111.561 93.7175 111.821 93.9775 111.821 94.2976V94.9976C111.821 95.3177 111.561 95.5777 111.241 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M111.241 100.298H110.541C110.221 100.298 109.961 100.038 109.961 99.7181V99.018C109.961 98.698 110.221 98.438 110.541 98.438H111.241C111.561 98.438 111.821 98.698 111.821 99.018V99.7181C111.821 100.018 111.561 100.298 111.241 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M114.7 13.1501H114C113.68 13.1501 113.42 12.8901 113.42 12.57V11.87C113.42 11.5499 113.68 11.2899 114 11.2899H114.7C115.02 11.2899 115.28 11.5499 115.28 11.87V12.57C115.3 12.8901 115.04 13.1501 114.7 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M114.7 17.8505H114C113.68 17.8505 113.42 17.5905 113.42 17.2705V16.5704C113.42 16.2504 113.68 15.9904 114 15.9904H114.7C115.02 15.9904 115.28 16.2504 115.28 16.5704V17.2705C115.3 17.5905 115.04 17.8505 114.7 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M114.7 22.571H114C113.68 22.571 113.42 22.311 113.42 21.9909V21.2909C113.42 20.9708 113.68 20.7108 114 20.7108H114.7C115.02 20.7108 115.28 20.9708 115.28 21.2909V21.9909C115.3 22.311 115.04 22.571 114.7 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M114.7 27.2714H114C113.68 27.2714 113.42 27.0114 113.42 26.6914V25.9913C113.42 25.6713 113.68 25.4113 114 25.4113H114.7C115.02 25.4113 115.28 25.6713 115.28 25.9913V26.6914C115.3 27.0114 115.04 27.2714 114.7 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M114.7 31.9919H114C113.68 31.9919 113.42 31.7319 113.42 31.4118V30.7118C113.42 30.3917 113.68 30.1317 114 30.1317H114.7C115.02 30.1317 115.28 30.3917 115.28 30.7118V31.4118C115.3 31.7119 115.04 31.9919 114.7 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M114.7 36.6923H114C113.68 36.6923 113.42 36.4323 113.42 36.1123V35.4122C113.42 35.0922 113.68 34.8322 114 34.8322H114.7C115.02 34.8322 115.28 35.0922 115.28 35.4122V36.1123C115.3 36.4323 115.04 36.6923 114.7 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M114.7 41.3928H114C113.68 41.3928 113.42 41.1327 113.42 40.8127V40.1127C113.42 39.7926 113.68 39.5326 114 39.5326H114.7C115.02 39.5326 115.28 39.7926 115.28 40.1127V40.8127C115.3 41.1327 115.04 41.3928 114.7 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M114.7 46.1131H114C113.68 46.1131 113.42 45.8531 113.42 45.5331V44.833C113.42 44.513 113.68 44.2529 114 44.2529H114.7C115.02 44.2529 115.28 44.513 115.28 44.833V45.5331C115.3 45.8531 115.04 46.1131 114.7 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M114.7 50.8136H114C113.68 50.8136 113.42 50.5535 113.42 50.2335V49.5335C113.42 49.2134 113.68 48.9534 114 48.9534H114.7C115.02 48.9534 115.28 49.2134 115.28 49.5335V50.2335C115.3 50.5535 115.04 50.8136 114.7 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M114.7 55.534H114C113.68 55.534 113.42 55.274 113.42 54.9539V54.2539C113.42 53.9338 113.68 53.6738 114 53.6738H114.7C115.02 53.6738 115.28 53.9338 115.28 54.2539V54.9539C115.3 55.254 115.04 55.534 114.7 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M114.7 60.2344H114C113.68 60.2344 113.42 59.9744 113.42 59.6544V58.9543C113.42 58.6343 113.68 58.3743 114 58.3743H114.7C115.02 58.3743 115.28 58.6343 115.28 58.9543V59.6544C115.3 59.9744 115.04 60.2344 114.7 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M114.7 64.9349H114C113.68 64.9349 113.42 64.6748 113.42 64.3548V63.6547C113.42 63.3347 113.68 63.0747 114 63.0747H114.7C115.02 63.0747 115.28 63.3347 115.28 63.6547V64.3548C115.3 64.6748 115.04 64.9349 114.7 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M114.7 69.6553H114C113.68 69.6553 113.42 69.3953 113.42 69.0753V68.3752C113.42 68.0552 113.68 67.7952 114 67.7952H114.7C115.02 67.7952 115.28 68.0552 115.28 68.3752V69.0753C115.3 69.3953 115.04 69.6553 114.7 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M114.7 74.3558H114C113.68 74.3558 113.42 74.0958 113.42 73.7758V73.0757C113.42 72.7557 113.68 72.4956 114 72.4956H114.7C115.02 72.4956 115.28 72.7557 115.28 73.0757V73.7758C115.3 74.0958 115.04 74.3558 114.7 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M114.7 79.0762H114C113.68 79.0762 113.42 78.8162 113.42 78.4962V77.7961C113.42 77.4761 113.68 77.2161 114 77.2161H114.7C115.02 77.2161 115.28 77.4761 115.28 77.7961V78.4962C115.3 78.7962 115.04 79.0762 114.7 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M114.7 83.7767H114C113.68 83.7767 113.42 83.5166 113.42 83.1966V82.4965C113.42 82.1765 113.68 81.9165 114 81.9165H114.7C115.02 81.9165 115.28 82.1765 115.28 82.4965V83.1966C115.3 83.5166 115.04 83.7767 114.7 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M114.7 88.4771H114C113.68 88.4771 113.42 88.2171 113.42 87.897V87.197C113.42 86.8769 113.68 86.6169 114 86.6169H114.7C115.02 86.6169 115.28 86.8769 115.28 87.197V87.897C115.3 88.2171 115.04 88.4771 114.7 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M114.7 93.1975H114C113.68 93.1975 113.42 92.9375 113.42 92.6175V91.9174C113.42 91.5974 113.68 91.3374 114 91.3374H114.7C115.02 91.3374 115.28 91.5974 115.28 91.9174V92.6175C115.3 92.9375 115.04 93.1975 114.7 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M114.7 97.898H114C113.68 97.898 113.42 97.638 113.42 97.3179V96.6179C113.42 96.2978 113.68 96.0378 114 96.0378H114.7C115.02 96.0378 115.28 96.2978 115.28 96.6179V97.3179C115.3 97.638 115.04 97.898 114.7 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M114.7 102.618H114C113.68 102.618 113.42 102.358 113.42 102.038V101.338C113.42 101.018 113.68 100.758 114 100.758H114.7C115.02 100.758 115.28 101.018 115.28 101.338V102.038C115.3 102.338 115.04 102.618 114.7 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M118.042 10.8299H117.342C117.022 10.8299 116.762 10.5699 116.762 10.2498V9.54976C116.762 9.22973 117.022 8.96973 117.342 8.96973H118.042C118.362 8.96973 118.622 9.22973 118.622 9.54976V10.2498C118.642 10.5699 118.382 10.8299 118.042 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M118.042 15.5503H117.342C117.022 15.5503 116.762 15.2903 116.762 14.9703V14.2702C116.762 13.9502 117.022 13.6902 117.342 13.6902H118.042C118.362 13.6902 118.622 13.9502 118.622 14.2702V14.9703C118.642 15.2703 118.382 15.5503 118.042 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M118.042 20.2508H117.342C117.022 20.2508 116.762 19.9908 116.762 19.6707V18.9707C116.762 18.6507 117.022 18.3906 117.342 18.3906H118.042C118.362 18.3906 118.622 18.6507 118.622 18.9707V19.6707C118.642 19.9908 118.382 20.2508 118.042 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M118.042 24.9512H117.342C117.022 24.9512 116.762 24.6912 116.762 24.3712V23.6711C116.762 23.3511 117.022 23.0911 117.342 23.0911H118.042C118.362 23.0911 118.622 23.3511 118.622 23.6711V24.3712C118.642 24.6912 118.382 24.9512 118.042 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M118.042 29.6717H117.342C117.022 29.6717 116.762 29.4117 116.762 29.0916V28.3916C116.762 28.0716 117.022 27.8115 117.342 27.8115H118.042C118.362 27.8115 118.622 28.0716 118.622 28.3916V29.0916C118.642 29.4117 118.382 29.6717 118.042 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M118.042 34.3721H117.342C117.022 34.3721 116.762 34.1121 116.762 33.7921V33.092C116.762 32.772 117.022 32.512 117.342 32.512H118.042C118.362 32.512 118.622 32.772 118.622 33.092V33.7921C118.642 34.1121 118.382 34.3721 118.042 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M118.042 39.0925H117.342C117.022 39.0925 116.762 38.8325 116.762 38.5124V37.8124C116.762 37.4923 117.022 37.2323 117.342 37.2323H118.042C118.362 37.2323 118.622 37.4923 118.622 37.8124V38.5124C118.642 38.8125 118.382 39.0925 118.042 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M118.042 43.7929H117.342C117.022 43.7929 116.762 43.5329 116.762 43.2129V42.5128C116.762 42.1928 117.022 41.9327 117.342 41.9327H118.042C118.362 41.9327 118.622 42.1928 118.622 42.5128V43.2129C118.642 43.5329 118.382 43.7929 118.042 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M118.042 48.4933H117.342C117.022 48.4933 116.762 48.2333 116.762 47.9133V47.2132C116.762 46.8932 117.022 46.6332 117.342 46.6332H118.042C118.362 46.6332 118.622 46.8932 118.622 47.2132V47.9133C118.642 48.2333 118.382 48.4933 118.042 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M118.042 53.2138H117.342C117.022 53.2138 116.762 52.9538 116.762 52.6338V51.9337C116.762 51.6137 117.022 51.3536 117.342 51.3536H118.042C118.362 51.3536 118.622 51.6137 118.622 51.9337V52.6338C118.642 52.9538 118.382 53.2138 118.042 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M118.042 57.9143H117.342C117.022 57.9143 116.762 57.6543 116.762 57.3342V56.6342C116.762 56.3141 117.022 56.0541 117.342 56.0541H118.042C118.362 56.0541 118.622 56.3141 118.622 56.6342V57.3342C118.642 57.6543 118.382 57.9143 118.042 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M118.042 62.6347H117.342C117.022 62.6347 116.762 62.3747 116.762 62.0546V61.3546C116.762 61.0345 117.022 60.7745 117.342 60.7745H118.042C118.362 60.7745 118.622 61.0345 118.622 61.3546V62.0546C118.642 62.3547 118.382 62.6347 118.042 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M118.042 67.3352H117.342C117.022 67.3352 116.762 67.0751 116.762 66.7551V66.055C116.762 65.735 117.022 65.475 117.342 65.475H118.042C118.362 65.475 118.622 65.735 118.622 66.055V66.7551C118.642 67.0751 118.382 67.3352 118.042 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M118.042 72.0356H117.342C117.022 72.0356 116.762 71.7755 116.762 71.4555V70.7554C116.762 70.4354 117.022 70.1754 117.342 70.1754H118.042C118.362 70.1754 118.622 70.4354 118.622 70.7554V71.4555C118.642 71.7755 118.382 72.0356 118.042 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M118.042 76.7559H117.342C117.022 76.7559 116.762 76.4959 116.762 76.1759V75.4758C116.762 75.1558 117.022 74.8958 117.342 74.8958H118.042C118.362 74.8958 118.622 75.1558 118.622 75.4758V76.1759C118.642 76.4759 118.382 76.7559 118.042 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M118.042 81.4564H117.342C117.022 81.4564 116.762 81.1964 116.762 80.8763V80.1763C116.762 79.8562 117.022 79.5962 117.342 79.5962H118.042C118.362 79.5962 118.622 79.8562 118.622 80.1763V80.8763C118.642 81.1964 118.382 81.4564 118.042 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M118.042 86.1568H117.342C117.022 86.1568 116.762 85.8968 116.762 85.5768V84.8767C116.762 84.5567 117.022 84.2966 117.342 84.2966H118.042C118.362 84.2966 118.622 84.5567 118.622 84.8767V85.5768C118.642 85.8968 118.382 86.1568 118.042 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M118.042 90.8773H117.342C117.022 90.8773 116.762 90.6172 116.762 90.2972V89.5971C116.762 89.2771 117.022 89.0171 117.342 89.0171H118.042C118.362 89.0171 118.622 89.2771 118.622 89.5971V90.2972C118.642 90.6172 118.382 90.8773 118.042 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M118.042 95.5777H117.342C117.022 95.5777 116.762 95.3177 116.762 94.9976V94.2976C116.762 93.9775 117.022 93.7175 117.342 93.7175H118.042C118.362 93.7175 118.622 93.9775 118.622 94.2976V94.9976C118.642 95.3177 118.382 95.5777 118.042 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M118.042 100.298H117.342C117.022 100.298 116.762 100.038 116.762 99.7181V99.018C116.762 98.698 117.022 98.438 117.342 98.438H118.042C118.362 98.438 118.622 98.698 118.622 99.018V99.7181C118.642 100.018 118.382 100.298 118.042 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M121.52 13.1501H120.82C120.5 13.1501 120.24 12.8901 120.24 12.57V11.87C120.24 11.5499 120.5 11.2899 120.82 11.2899H121.52C121.84 11.2899 122.1 11.5499 122.1 11.87V12.57C122.12 12.8901 121.84 13.1501 121.52 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M121.52 17.8505H120.82C120.5 17.8505 120.24 17.5905 120.24 17.2705V16.5704C120.24 16.2504 120.5 15.9904 120.82 15.9904H121.52C121.84 15.9904 122.1 16.2504 122.1 16.5704V17.2705C122.12 17.5905 121.84 17.8505 121.52 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M121.52 22.571H120.82C120.5 22.571 120.24 22.311 120.24 21.9909V21.2909C120.24 20.9708 120.5 20.7108 120.82 20.7108H121.52C121.84 20.7108 122.1 20.9708 122.1 21.2909V21.9909C122.12 22.311 121.84 22.571 121.52 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M121.52 27.2714H120.82C120.5 27.2714 120.24 27.0114 120.24 26.6914V25.9913C120.24 25.6713 120.5 25.4113 120.82 25.4113H121.52C121.84 25.4113 122.1 25.6713 122.1 25.9913V26.6914C122.12 27.0114 121.84 27.2714 121.52 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M121.52 31.9919H120.82C120.5 31.9919 120.24 31.7319 120.24 31.4118V30.7118C120.24 30.3917 120.5 30.1317 120.82 30.1317H121.52C121.84 30.1317 122.1 30.3917 122.1 30.7118V31.4118C122.12 31.7119 121.84 31.9919 121.52 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M121.52 36.6923H120.82C120.5 36.6923 120.24 36.4323 120.24 36.1123V35.4122C120.24 35.0922 120.5 34.8322 120.82 34.8322H121.52C121.84 34.8322 122.1 35.0922 122.1 35.4122V36.1123C122.12 36.4323 121.84 36.6923 121.52 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M121.52 41.3928H120.82C120.5 41.3928 120.24 41.1327 120.24 40.8127V40.1127C120.24 39.7926 120.5 39.5326 120.82 39.5326H121.52C121.84 39.5326 122.1 39.7926 122.1 40.1127V40.8127C122.12 41.1327 121.84 41.3928 121.52 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M121.52 46.1131H120.82C120.5 46.1131 120.24 45.8531 120.24 45.5331V44.833C120.24 44.513 120.5 44.2529 120.82 44.2529H121.52C121.84 44.2529 122.1 44.513 122.1 44.833V45.5331C122.12 45.8531 121.84 46.1131 121.52 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M121.52 50.8136H120.82C120.5 50.8136 120.24 50.5535 120.24 50.2335V49.5335C120.24 49.2134 120.5 48.9534 120.82 48.9534H121.52C121.84 48.9534 122.1 49.2134 122.1 49.5335V50.2335C122.12 50.5535 121.84 50.8136 121.52 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M121.52 55.534H120.82C120.5 55.534 120.24 55.274 120.24 54.9539V54.2539C120.24 53.9338 120.5 53.6738 120.82 53.6738H121.52C121.84 53.6738 122.1 53.9338 122.1 54.2539V54.9539C122.12 55.254 121.84 55.534 121.52 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M121.52 60.2344H120.82C120.5 60.2344 120.24 59.9744 120.24 59.6544V58.9543C120.24 58.6343 120.5 58.3743 120.82 58.3743H121.52C121.84 58.3743 122.1 58.6343 122.1 58.9543V59.6544C122.12 59.9744 121.84 60.2344 121.52 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M121.52 64.9349H120.82C120.5 64.9349 120.24 64.6748 120.24 64.3548V63.6547C120.24 63.3347 120.5 63.0747 120.82 63.0747H121.52C121.84 63.0747 122.1 63.3347 122.1 63.6547V64.3548C122.12 64.6748 121.84 64.9349 121.52 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M121.52 69.6553H120.82C120.5 69.6553 120.24 69.3953 120.24 69.0753V68.3752C120.24 68.0552 120.5 67.7952 120.82 67.7952H121.52C121.84 67.7952 122.1 68.0552 122.1 68.3752V69.0753C122.12 69.3953 121.84 69.6553 121.52 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M121.52 74.3558H120.82C120.5 74.3558 120.24 74.0958 120.24 73.7758V73.0757C120.24 72.7557 120.5 72.4956 120.82 72.4956H121.52C121.84 72.4956 122.1 72.7557 122.1 73.0757V73.7758C122.12 74.0958 121.84 74.3558 121.52 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M121.52 79.0762H120.82C120.5 79.0762 120.24 78.8162 120.24 78.4962V77.7961C120.24 77.4761 120.5 77.2161 120.82 77.2161H121.52C121.84 77.2161 122.1 77.4761 122.1 77.7961V78.4962C122.12 78.7962 121.84 79.0762 121.52 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M121.52 83.7767H120.82C120.5 83.7767 120.24 83.5166 120.24 83.1966V82.4965C120.24 82.1765 120.5 81.9165 120.82 81.9165H121.52C121.84 81.9165 122.1 82.1765 122.1 82.4965V83.1966C122.12 83.5166 121.84 83.7767 121.52 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M121.52 88.4771H120.82C120.5 88.4771 120.24 88.2171 120.24 87.897V87.197C120.24 86.8769 120.5 86.6169 120.82 86.6169H121.52C121.84 86.6169 122.1 86.8769 122.1 87.197V87.897C122.12 88.2171 121.84 88.4771 121.52 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M121.52 93.1975H120.82C120.5 93.1975 120.24 92.9375 120.24 92.6175V91.9174C120.24 91.5974 120.5 91.3374 120.82 91.3374H121.52C121.84 91.3374 122.1 91.5974 122.1 91.9174V92.6175C122.12 92.9375 121.84 93.1975 121.52 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M121.52 97.898H120.82C120.5 97.898 120.24 97.638 120.24 97.3179V96.6179C120.24 96.2978 120.5 96.0378 120.82 96.0378H121.52C121.84 96.0378 122.1 96.2978 122.1 96.6179V97.3179C122.12 97.638 121.84 97.898 121.52 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M121.52 102.618H120.82C120.5 102.618 120.24 102.358 120.24 102.038V101.338C120.24 101.018 120.5 100.758 120.82 100.758H121.52C121.84 100.758 122.1 101.018 122.1 101.338V102.038C122.12 102.338 121.84 102.618 121.52 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M124.862 10.8299H124.162C123.842 10.8299 123.582 10.5699 123.582 10.2498V9.54976C123.582 9.22973 123.842 8.96973 124.162 8.96973H124.862C125.182 8.96973 125.442 9.22973 125.442 9.54976V10.2498C125.462 10.5699 125.202 10.8299 124.862 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M124.862 15.5503H124.162C123.842 15.5503 123.582 15.2903 123.582 14.9703V14.2702C123.582 13.9502 123.842 13.6902 124.162 13.6902H124.862C125.182 13.6902 125.442 13.9502 125.442 14.2702V14.9703C125.462 15.2703 125.202 15.5503 124.862 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M124.862 20.2508H124.162C123.842 20.2508 123.582 19.9908 123.582 19.6707V18.9707C123.582 18.6507 123.842 18.3906 124.162 18.3906H124.862C125.182 18.3906 125.442 18.6507 125.442 18.9707V19.6707C125.462 19.9908 125.202 20.2508 124.862 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M124.862 24.9512H124.162C123.842 24.9512 123.582 24.6912 123.582 24.3712V23.6711C123.582 23.3511 123.842 23.0911 124.162 23.0911H124.862C125.182 23.0911 125.442 23.3511 125.442 23.6711V24.3712C125.462 24.6912 125.202 24.9512 124.862 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M124.862 29.6717H124.162C123.842 29.6717 123.582 29.4117 123.582 29.0916V28.3916C123.582 28.0716 123.842 27.8115 124.162 27.8115H124.862C125.182 27.8115 125.442 28.0716 125.442 28.3916V29.0916C125.462 29.4117 125.202 29.6717 124.862 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M124.862 34.3721H124.162C123.842 34.3721 123.582 34.1121 123.582 33.7921V33.092C123.582 32.772 123.842 32.512 124.162 32.512H124.862C125.182 32.512 125.442 32.772 125.442 33.092V33.7921C125.462 34.1121 125.202 34.3721 124.862 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M124.862 39.0925H124.162C123.842 39.0925 123.582 38.8325 123.582 38.5124V37.8124C123.582 37.4923 123.842 37.2323 124.162 37.2323H124.862C125.182 37.2323 125.442 37.4923 125.442 37.8124V38.5124C125.462 38.8125 125.202 39.0925 124.862 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M124.862 43.7929H124.162C123.842 43.7929 123.582 43.5329 123.582 43.2129V42.5128C123.582 42.1928 123.842 41.9327 124.162 41.9327H124.862C125.182 41.9327 125.442 42.1928 125.442 42.5128V43.2129C125.462 43.5329 125.202 43.7929 124.862 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M124.862 48.4933H124.162C123.842 48.4933 123.582 48.2333 123.582 47.9133V47.2132C123.582 46.8932 123.842 46.6332 124.162 46.6332H124.862C125.182 46.6332 125.442 46.8932 125.442 47.2132V47.9133C125.462 48.2333 125.202 48.4933 124.862 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M124.862 53.2138H124.162C123.842 53.2138 123.582 52.9538 123.582 52.6338V51.9337C123.582 51.6137 123.842 51.3536 124.162 51.3536H124.862C125.182 51.3536 125.442 51.6137 125.442 51.9337V52.6338C125.462 52.9538 125.202 53.2138 124.862 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M124.862 57.9143H124.162C123.842 57.9143 123.582 57.6543 123.582 57.3342V56.6342C123.582 56.3141 123.842 56.0541 124.162 56.0541H124.862C125.182 56.0541 125.442 56.3141 125.442 56.6342V57.3342C125.462 57.6543 125.202 57.9143 124.862 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M124.862 62.6347H124.162C123.842 62.6347 123.582 62.3747 123.582 62.0546V61.3546C123.582 61.0345 123.842 60.7745 124.162 60.7745H124.862C125.182 60.7745 125.442 61.0345 125.442 61.3546V62.0546C125.462 62.3547 125.202 62.6347 124.862 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M124.862 67.3352H124.162C123.842 67.3352 123.582 67.0751 123.582 66.7551V66.055C123.582 65.735 123.842 65.475 124.162 65.475H124.862C125.182 65.475 125.442 65.735 125.442 66.055V66.7551C125.462 67.0751 125.202 67.3352 124.862 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M124.862 72.0356H124.162C123.842 72.0356 123.582 71.7755 123.582 71.4555V70.7554C123.582 70.4354 123.842 70.1754 124.162 70.1754H124.862C125.182 70.1754 125.442 70.4354 125.442 70.7554V71.4555C125.462 71.7755 125.202 72.0356 124.862 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M124.862 76.7559H124.162C123.842 76.7559 123.582 76.4959 123.582 76.1759V75.4758C123.582 75.1558 123.842 74.8958 124.162 74.8958H124.862C125.182 74.8958 125.442 75.1558 125.442 75.4758V76.1759C125.462 76.4759 125.202 76.7559 124.862 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M124.862 81.4564H124.162C123.842 81.4564 123.582 81.1964 123.582 80.8763V80.1763C123.582 79.8562 123.842 79.5962 124.162 79.5962H124.862C125.182 79.5962 125.442 79.8562 125.442 80.1763V80.8763C125.462 81.1964 125.202 81.4564 124.862 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M124.862 86.1568H124.162C123.842 86.1568 123.582 85.8968 123.582 85.5768V84.8767C123.582 84.5567 123.842 84.2966 124.162 84.2966H124.862C125.182 84.2966 125.442 84.5567 125.442 84.8767V85.5768C125.462 85.8968 125.202 86.1568 124.862 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M124.862 90.8773H124.162C123.842 90.8773 123.582 90.6172 123.582 90.2972V89.5971C123.582 89.2771 123.842 89.0171 124.162 89.0171H124.862C125.182 89.0171 125.442 89.2771 125.442 89.5971V90.2972C125.462 90.6172 125.202 90.8773 124.862 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M124.862 95.5777H124.162C123.842 95.5777 123.582 95.3177 123.582 94.9976V94.2976C123.582 93.9775 123.842 93.7175 124.162 93.7175H124.862C125.182 93.7175 125.442 93.9775 125.442 94.2976V94.9976C125.462 95.3177 125.202 95.5777 124.862 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M124.862 100.298H124.162C123.842 100.298 123.582 100.038 123.582 99.7181V99.018C123.582 98.698 123.842 98.438 124.162 98.438H124.862C125.182 98.438 125.442 98.698 125.442 99.018V99.7181C125.462 100.018 125.202 100.298 124.862 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M128.343 13.1501H127.643C127.323 13.1501 127.062 12.8901 127.062 12.57V11.87C127.062 11.5499 127.323 11.2899 127.643 11.2899H128.343C128.663 11.2899 128.923 11.5499 128.923 11.87V12.57C128.943 12.8901 128.663 13.1501 128.343 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M128.343 17.8505H127.643C127.323 17.8505 127.062 17.5905 127.062 17.2705V16.5704C127.062 16.2504 127.323 15.9904 127.643 15.9904H128.343C128.663 15.9904 128.923 16.2504 128.923 16.5704V17.2705C128.943 17.5905 128.663 17.8505 128.343 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M128.343 22.571H127.643C127.323 22.571 127.062 22.311 127.062 21.9909V21.2909C127.062 20.9708 127.323 20.7108 127.643 20.7108H128.343C128.663 20.7108 128.923 20.9708 128.923 21.2909V21.9909C128.943 22.311 128.663 22.571 128.343 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M128.343 27.2714H127.643C127.323 27.2714 127.062 27.0114 127.062 26.6914V25.9913C127.062 25.6713 127.323 25.4113 127.643 25.4113H128.343C128.663 25.4113 128.923 25.6713 128.923 25.9913V26.6914C128.943 27.0114 128.663 27.2714 128.343 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M128.343 31.9919H127.643C127.323 31.9919 127.062 31.7319 127.062 31.4118V30.7118C127.062 30.3917 127.323 30.1317 127.643 30.1317H128.343C128.663 30.1317 128.923 30.3917 128.923 30.7118V31.4118C128.943 31.7119 128.663 31.9919 128.343 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M128.343 36.6923H127.643C127.323 36.6923 127.062 36.4323 127.062 36.1123V35.4122C127.062 35.0922 127.323 34.8322 127.643 34.8322H128.343C128.663 34.8322 128.923 35.0922 128.923 35.4122V36.1123C128.943 36.4323 128.663 36.6923 128.343 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M128.343 41.3928H127.643C127.323 41.3928 127.062 41.1327 127.062 40.8127V40.1127C127.062 39.7926 127.323 39.5326 127.643 39.5326H128.343C128.663 39.5326 128.923 39.7926 128.923 40.1127V40.8127C128.943 41.1327 128.663 41.3928 128.343 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M128.343 46.1131H127.643C127.323 46.1131 127.062 45.8531 127.062 45.5331V44.833C127.062 44.513 127.323 44.2529 127.643 44.2529H128.343C128.663 44.2529 128.923 44.513 128.923 44.833V45.5331C128.943 45.8531 128.663 46.1131 128.343 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M128.343 50.8136H127.643C127.323 50.8136 127.062 50.5535 127.062 50.2335V49.5335C127.062 49.2134 127.323 48.9534 127.643 48.9534H128.343C128.663 48.9534 128.923 49.2134 128.923 49.5335V50.2335C128.943 50.5535 128.663 50.8136 128.343 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M128.343 55.534H127.643C127.323 55.534 127.062 55.274 127.062 54.9539V54.2539C127.062 53.9338 127.323 53.6738 127.643 53.6738H128.343C128.663 53.6738 128.923 53.9338 128.923 54.2539V54.9539C128.943 55.254 128.663 55.534 128.343 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M128.343 60.2344H127.643C127.323 60.2344 127.062 59.9744 127.062 59.6544V58.9543C127.062 58.6343 127.323 58.3743 127.643 58.3743H128.343C128.663 58.3743 128.923 58.6343 128.923 58.9543V59.6544C128.943 59.9744 128.663 60.2344 128.343 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M128.343 64.9349H127.643C127.323 64.9349 127.062 64.6748 127.062 64.3548V63.6547C127.062 63.3347 127.323 63.0747 127.643 63.0747H128.343C128.663 63.0747 128.923 63.3347 128.923 63.6547V64.3548C128.943 64.6748 128.663 64.9349 128.343 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M128.343 69.6553H127.643C127.323 69.6553 127.062 69.3953 127.062 69.0753V68.3752C127.062 68.0552 127.323 67.7952 127.643 67.7952H128.343C128.663 67.7952 128.923 68.0552 128.923 68.3752V69.0753C128.943 69.3953 128.663 69.6553 128.343 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M128.343 74.3558H127.643C127.323 74.3558 127.062 74.0958 127.062 73.7758V73.0757C127.062 72.7557 127.323 72.4956 127.643 72.4956H128.343C128.663 72.4956 128.923 72.7557 128.923 73.0757V73.7758C128.943 74.0958 128.663 74.3558 128.343 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M128.343 79.0762H127.643C127.323 79.0762 127.062 78.8162 127.062 78.4962V77.7961C127.062 77.4761 127.323 77.2161 127.643 77.2161H128.343C128.663 77.2161 128.923 77.4761 128.923 77.7961V78.4962C128.943 78.7962 128.663 79.0762 128.343 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M128.343 83.7767H127.643C127.323 83.7767 127.062 83.5166 127.062 83.1966V82.4965C127.062 82.1765 127.323 81.9165 127.643 81.9165H128.343C128.663 81.9165 128.923 82.1765 128.923 82.4965V83.1966C128.943 83.5166 128.663 83.7767 128.343 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M128.343 88.4771H127.643C127.323 88.4771 127.062 88.2171 127.062 87.897V87.197C127.062 86.8769 127.323 86.6169 127.643 86.6169H128.343C128.663 86.6169 128.923 86.8769 128.923 87.197V87.897C128.943 88.2171 128.663 88.4771 128.343 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M128.343 93.1975H127.643C127.323 93.1975 127.062 92.9375 127.062 92.6175V91.9174C127.062 91.5974 127.323 91.3374 127.643 91.3374H128.343C128.663 91.3374 128.923 91.5974 128.923 91.9174V92.6175C128.943 92.9375 128.663 93.1975 128.343 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M128.343 97.898H127.643C127.323 97.898 127.062 97.638 127.062 97.3179V96.6179C127.062 96.2978 127.323 96.0378 127.643 96.0378H128.343C128.663 96.0378 128.923 96.2978 128.923 96.6179V97.3179C128.943 97.638 128.663 97.898 128.343 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M128.343 102.618H127.643C127.323 102.618 127.062 102.358 127.062 102.038V101.338C127.062 101.018 127.323 100.758 127.643 100.758H128.343C128.663 100.758 128.923 101.018 128.923 101.338V102.038C128.943 102.338 128.663 102.618 128.343 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M131.682 10.8299H130.982C130.662 10.8299 130.402 10.5699 130.402 10.2498V9.54976C130.402 9.22973 130.662 8.96973 130.982 8.96973H131.682C132.002 8.96973 132.262 9.22973 132.262 9.54976V10.2498C132.282 10.5699 132.002 10.8299 131.682 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M131.682 15.5503H130.982C130.662 15.5503 130.402 15.2903 130.402 14.9703V14.2702C130.402 13.9502 130.662 13.6902 130.982 13.6902H131.682C132.002 13.6902 132.262 13.9502 132.262 14.2702V14.9703C132.282 15.2703 132.002 15.5503 131.682 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M131.682 20.2508H130.982C130.662 20.2508 130.402 19.9908 130.402 19.6707V18.9707C130.402 18.6507 130.662 18.3906 130.982 18.3906H131.682C132.002 18.3906 132.262 18.6507 132.262 18.9707V19.6707C132.282 19.9908 132.002 20.2508 131.682 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M131.682 24.9512H130.982C130.662 24.9512 130.402 24.6912 130.402 24.3712V23.6711C130.402 23.3511 130.662 23.0911 130.982 23.0911H131.682C132.002 23.0911 132.262 23.3511 132.262 23.6711V24.3712C132.282 24.6912 132.002 24.9512 131.682 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M131.682 29.6717H130.982C130.662 29.6717 130.402 29.4117 130.402 29.0916V28.3916C130.402 28.0716 130.662 27.8115 130.982 27.8115H131.682C132.002 27.8115 132.262 28.0716 132.262 28.3916V29.0916C132.282 29.4117 132.002 29.6717 131.682 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M131.682 34.3721H130.982C130.662 34.3721 130.402 34.1121 130.402 33.7921V33.092C130.402 32.772 130.662 32.512 130.982 32.512H131.682C132.002 32.512 132.262 32.772 132.262 33.092V33.7921C132.282 34.1121 132.002 34.3721 131.682 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M131.682 39.0925H130.982C130.662 39.0925 130.402 38.8325 130.402 38.5124V37.8124C130.402 37.4923 130.662 37.2323 130.982 37.2323H131.682C132.002 37.2323 132.262 37.4923 132.262 37.8124V38.5124C132.282 38.8125 132.002 39.0925 131.682 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M131.682 43.7929H130.982C130.662 43.7929 130.402 43.5329 130.402 43.2129V42.5128C130.402 42.1928 130.662 41.9327 130.982 41.9327H131.682C132.002 41.9327 132.262 42.1928 132.262 42.5128V43.2129C132.282 43.5329 132.002 43.7929 131.682 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M131.682 48.4933H130.982C130.662 48.4933 130.402 48.2333 130.402 47.9133V47.2132C130.402 46.8932 130.662 46.6332 130.982 46.6332H131.682C132.002 46.6332 132.262 46.8932 132.262 47.2132V47.9133C132.282 48.2333 132.002 48.4933 131.682 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M131.682 53.2138H130.982C130.662 53.2138 130.402 52.9538 130.402 52.6338V51.9337C130.402 51.6137 130.662 51.3536 130.982 51.3536H131.682C132.002 51.3536 132.262 51.6137 132.262 51.9337V52.6338C132.282 52.9538 132.002 53.2138 131.682 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M131.682 57.9143H130.982C130.662 57.9143 130.402 57.6543 130.402 57.3342V56.6342C130.402 56.3141 130.662 56.0541 130.982 56.0541H131.682C132.002 56.0541 132.262 56.3141 132.262 56.6342V57.3342C132.282 57.6543 132.002 57.9143 131.682 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M131.682 62.6347H130.982C130.662 62.6347 130.402 62.3747 130.402 62.0546V61.3546C130.402 61.0345 130.662 60.7745 130.982 60.7745H131.682C132.002 60.7745 132.262 61.0345 132.262 61.3546V62.0546C132.282 62.3547 132.002 62.6347 131.682 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M131.682 67.3352H130.982C130.662 67.3352 130.402 67.0751 130.402 66.7551V66.055C130.402 65.735 130.662 65.475 130.982 65.475H131.682C132.002 65.475 132.262 65.735 132.262 66.055V66.7551C132.282 67.0751 132.002 67.3352 131.682 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M131.682 72.0356H130.982C130.662 72.0356 130.402 71.7755 130.402 71.4555V70.7554C130.402 70.4354 130.662 70.1754 130.982 70.1754H131.682C132.002 70.1754 132.262 70.4354 132.262 70.7554V71.4555C132.282 71.7755 132.002 72.0356 131.682 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M131.682 76.7559H130.982C130.662 76.7559 130.402 76.4959 130.402 76.1759V75.4758C130.402 75.1558 130.662 74.8958 130.982 74.8958H131.682C132.002 74.8958 132.262 75.1558 132.262 75.4758V76.1759C132.282 76.4759 132.002 76.7559 131.682 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M131.682 81.4564H130.982C130.662 81.4564 130.402 81.1964 130.402 80.8763V80.1763C130.402 79.8562 130.662 79.5962 130.982 79.5962H131.682C132.002 79.5962 132.262 79.8562 132.262 80.1763V80.8763C132.282 81.1964 132.002 81.4564 131.682 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M131.682 86.1568H130.982C130.662 86.1568 130.402 85.8968 130.402 85.5768V84.8767C130.402 84.5567 130.662 84.2966 130.982 84.2966H131.682C132.002 84.2966 132.262 84.5567 132.262 84.8767V85.5768C132.282 85.8968 132.002 86.1568 131.682 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M131.682 90.8773H130.982C130.662 90.8773 130.402 90.6172 130.402 90.2972V89.5971C130.402 89.2771 130.662 89.0171 130.982 89.0171H131.682C132.002 89.0171 132.262 89.2771 132.262 89.5971V90.2972C132.282 90.6172 132.002 90.8773 131.682 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M131.682 95.5777H130.982C130.662 95.5777 130.402 95.3177 130.402 94.9976V94.2976C130.402 93.9775 130.662 93.7175 130.982 93.7175H131.682C132.002 93.7175 132.262 93.9775 132.262 94.2976V94.9976C132.282 95.3177 132.002 95.5777 131.682 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M131.682 100.298H130.982C130.662 100.298 130.402 100.038 130.402 99.7181V99.018C130.402 98.698 130.662 98.438 130.982 98.438H131.682C132.002 98.438 132.262 98.698 132.262 99.018V99.7181C132.282 100.018 132.002 100.298 131.682 100.298Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M135.163 13.1501H134.463C134.143 13.1501 133.883 12.8901 133.883 12.57V11.87C133.883 11.5499 134.143 11.2899 134.463 11.2899H135.163C135.483 11.2899 135.743 11.5499 135.743 11.87V12.57C135.743 12.8901 135.483 13.1501 135.163 13.1501Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M135.163 17.8505H134.463C134.143 17.8505 133.883 17.5905 133.883 17.2705V16.5704C133.883 16.2504 134.143 15.9904 134.463 15.9904H135.163C135.483 15.9904 135.743 16.2504 135.743 16.5704V17.2705C135.743 17.5905 135.483 17.8505 135.163 17.8505Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M135.163 22.571H134.463C134.143 22.571 133.883 22.311 133.883 21.9909V21.2909C133.883 20.9708 134.143 20.7108 134.463 20.7108H135.163C135.483 20.7108 135.743 20.9708 135.743 21.2909V21.9909C135.743 22.311 135.483 22.571 135.163 22.571Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M135.163 27.2714H134.463C134.143 27.2714 133.883 27.0114 133.883 26.6914V25.9913C133.883 25.6713 134.143 25.4113 134.463 25.4113H135.163C135.483 25.4113 135.743 25.6713 135.743 25.9913V26.6914C135.743 27.0114 135.483 27.2714 135.163 27.2714Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    d: "M135.163 31.9919H134.463C134.143 31.9919 133.883 31.7319 133.883 31.4118V30.7118C133.883 30.3917 134.143 30.1317 134.463 30.1317H135.163C135.483 30.1317 135.743 30.3917 135.743 30.7118V31.4118C135.743 31.7119 135.483 31.9919 135.163 31.9919Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    d: "M135.163 36.6923H134.463C134.143 36.6923 133.883 36.4323 133.883 36.1123V35.4122C133.883 35.0922 134.143 34.8322 134.463 34.8322H135.163C135.483 34.8322 135.743 35.0922 135.743 35.4122V36.1123C135.743 36.4323 135.483 36.6923 135.163 36.6923Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    d: "M135.163 41.3928H134.463C134.143 41.3928 133.883 41.1327 133.883 40.8127V40.1127C133.883 39.7926 134.143 39.5326 134.463 39.5326H135.163C135.483 39.5326 135.743 39.7926 135.743 40.1127V40.8127C135.743 41.1327 135.483 41.3928 135.163 41.3928Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    d: "M135.163 46.1131H134.463C134.143 46.1131 133.883 45.8531 133.883 45.5331V44.833C133.883 44.513 134.143 44.2529 134.463 44.2529H135.163C135.483 44.2529 135.743 44.513 135.743 44.833V45.5331C135.743 45.8531 135.483 46.1131 135.163 46.1131Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    d: "M135.163 50.8136H134.463C134.143 50.8136 133.883 50.5535 133.883 50.2335V49.5335C133.883 49.2134 134.143 48.9534 134.463 48.9534H135.163C135.483 48.9534 135.743 49.2134 135.743 49.5335V50.2335C135.743 50.5535 135.483 50.8136 135.163 50.8136Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    d: "M135.163 55.534H134.463C134.143 55.534 133.883 55.274 133.883 54.9539V54.2539C133.883 53.9338 134.143 53.6738 134.463 53.6738H135.163C135.483 53.6738 135.743 53.9338 135.743 54.2539V54.9539C135.743 55.254 135.483 55.534 135.163 55.534Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    d: "M135.163 60.2344H134.463C134.143 60.2344 133.883 59.9744 133.883 59.6544V58.9543C133.883 58.6343 134.143 58.3743 134.463 58.3743H135.163C135.483 58.3743 135.743 58.6343 135.743 58.9543V59.6544C135.743 59.9744 135.483 60.2344 135.163 60.2344Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    d: "M135.163 64.9349H134.463C134.143 64.9349 133.883 64.6748 133.883 64.3548V63.6547C133.883 63.3347 134.143 63.0747 134.463 63.0747H135.163C135.483 63.0747 135.743 63.3347 135.743 63.6547V64.3548C135.743 64.6748 135.483 64.9349 135.163 64.9349Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    d: "M135.163 69.6553H134.463C134.143 69.6553 133.883 69.3953 133.883 69.0753V68.3752C133.883 68.0552 134.143 67.7952 134.463 67.7952H135.163C135.483 67.7952 135.743 68.0552 135.743 68.3752V69.0753C135.743 69.3953 135.483 69.6553 135.163 69.6553Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    d: "M135.163 74.3558H134.463C134.143 74.3558 133.883 74.0958 133.883 73.7758V73.0757C133.883 72.7557 134.143 72.4956 134.463 72.4956H135.163C135.483 72.4956 135.743 72.7557 135.743 73.0757V73.7758C135.743 74.0958 135.483 74.3558 135.163 74.3558Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    d: "M135.163 79.0762H134.463C134.143 79.0762 133.883 78.8162 133.883 78.4962V77.7961C133.883 77.4761 134.143 77.2161 134.463 77.2161H135.163C135.483 77.2161 135.743 77.4761 135.743 77.7961V78.4962C135.743 78.7962 135.483 79.0762 135.163 79.0762Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    d: "M135.163 83.7767H134.463C134.143 83.7767 133.883 83.5166 133.883 83.1966V82.4965C133.883 82.1765 134.143 81.9165 134.463 81.9165H135.163C135.483 81.9165 135.743 82.1765 135.743 82.4965V83.1966C135.743 83.5166 135.483 83.7767 135.163 83.7767Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    d: "M135.163 88.4771H134.463C134.143 88.4771 133.883 88.2171 133.883 87.897V87.197C133.883 86.8769 134.143 86.6169 134.463 86.6169H135.163C135.483 86.6169 135.743 86.8769 135.743 87.197V87.897C135.743 88.2171 135.483 88.4771 135.163 88.4771Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    d: "M135.163 93.1975H134.463C134.143 93.1975 133.883 92.9375 133.883 92.6175V91.9174C133.883 91.5974 134.143 91.3374 134.463 91.3374H135.163C135.483 91.3374 135.743 91.5974 135.743 91.9174V92.6175C135.743 92.9375 135.483 93.1975 135.163 93.1975Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    d: "M135.163 97.898H134.463C134.143 97.898 133.883 97.638 133.883 97.3179V96.6179C133.883 96.2978 134.143 96.0378 134.463 96.0378H135.163C135.483 96.0378 135.743 96.2978 135.743 96.6179V97.3179C135.743 97.638 135.483 97.898 135.163 97.898Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    d: "M135.163 102.618H134.463C134.143 102.618 133.883 102.358 133.883 102.038V101.338C133.883 101.018 134.143 100.758 134.463 100.758H135.163C135.483 100.758 135.743 101.018 135.743 101.338V102.038C135.743 102.338 135.483 102.618 135.163 102.618Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    d: "M138.503 10.8299H137.803C137.483 10.8299 137.223 10.5699 137.223 10.2498V9.54976C137.223 9.22973 137.483 8.96973 137.803 8.96973H138.503C138.823 8.96973 139.083 9.22973 139.083 9.54976V10.2498C139.083 10.5699 138.823 10.8299 138.503 10.8299Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    d: "M138.503 15.5503H137.803C137.483 15.5503 137.223 15.2903 137.223 14.9703V14.2702C137.223 13.9502 137.483 13.6902 137.803 13.6902H138.503C138.823 13.6902 139.083 13.9502 139.083 14.2702V14.9703C139.083 15.2703 138.823 15.5503 138.503 15.5503Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    d: "M138.503 20.2508H137.803C137.483 20.2508 137.223 19.9908 137.223 19.6707V18.9707C137.223 18.6507 137.483 18.3906 137.803 18.3906H138.503C138.823 18.3906 139.083 18.6507 139.083 18.9707V19.6707C139.083 19.9908 138.823 20.2508 138.503 20.2508Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    d: "M138.503 24.9512H137.803C137.483 24.9512 137.223 24.6912 137.223 24.3712V23.6711C137.223 23.3511 137.483 23.0911 137.803 23.0911H138.503C138.823 23.0911 139.083 23.3511 139.083 23.6711V24.3712C139.083 24.6912 138.823 24.9512 138.503 24.9512Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    d: "M138.503 29.6717H137.803C137.483 29.6717 137.223 29.4117 137.223 29.0916V28.3916C137.223 28.0716 137.483 27.8115 137.803 27.8115H138.503C138.823 27.8115 139.083 28.0716 139.083 28.3916V29.0916C139.083 29.4117 138.823 29.6717 138.503 29.6717Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    d: "M138.503 34.3721H137.803C137.483 34.3721 137.223 34.1121 137.223 33.7921V33.092C137.223 32.772 137.483 32.512 137.803 32.512H138.503C138.823 32.512 139.083 32.772 139.083 33.092V33.7921C139.083 34.1121 138.823 34.3721 138.503 34.3721Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    d: "M138.503 39.0925H137.803C137.483 39.0925 137.223 38.8325 137.223 38.5124V37.8124C137.223 37.4923 137.483 37.2323 137.803 37.2323H138.503C138.823 37.2323 139.083 37.4923 139.083 37.8124V38.5124C139.083 38.8125 138.823 39.0925 138.503 39.0925Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    d: "M138.503 43.7929H137.803C137.483 43.7929 137.223 43.5329 137.223 43.2129V42.5128C137.223 42.1928 137.483 41.9327 137.803 41.9327H138.503C138.823 41.9327 139.083 42.1928 139.083 42.5128V43.2129C139.083 43.5329 138.823 43.7929 138.503 43.7929Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    d: "M138.503 48.4933H137.803C137.483 48.4933 137.223 48.2333 137.223 47.9133V47.2132C137.223 46.8932 137.483 46.6332 137.803 46.6332H138.503C138.823 46.6332 139.083 46.8932 139.083 47.2132V47.9133C139.083 48.2333 138.823 48.4933 138.503 48.4933Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    d: "M138.503 53.2138H137.803C137.483 53.2138 137.223 52.9538 137.223 52.6338V51.9337C137.223 51.6137 137.483 51.3536 137.803 51.3536H138.503C138.823 51.3536 139.083 51.6137 139.083 51.9337V52.6338C139.083 52.9538 138.823 53.2138 138.503 53.2138Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    d: "M138.503 57.9143H137.803C137.483 57.9143 137.223 57.6543 137.223 57.3342V56.6342C137.223 56.3141 137.483 56.0541 137.803 56.0541H138.503C138.823 56.0541 139.083 56.3141 139.083 56.6342V57.3342C139.083 57.6543 138.823 57.9143 138.503 57.9143Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    d: "M138.503 62.6347H137.803C137.483 62.6347 137.223 62.3747 137.223 62.0546V61.3546C137.223 61.0345 137.483 60.7745 137.803 60.7745H138.503C138.823 60.7745 139.083 61.0345 139.083 61.3546V62.0546C139.083 62.3547 138.823 62.6347 138.503 62.6347Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    d: "M138.503 67.3352H137.803C137.483 67.3352 137.223 67.0751 137.223 66.7551V66.055C137.223 65.735 137.483 65.475 137.803 65.475H138.503C138.823 65.475 139.083 65.735 139.083 66.055V66.7551C139.083 67.0751 138.823 67.3352 138.503 67.3352Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    d: "M138.503 72.0356H137.803C137.483 72.0356 137.223 71.7755 137.223 71.4555V70.7554C137.223 70.4354 137.483 70.1754 137.803 70.1754H138.503C138.823 70.1754 139.083 70.4354 139.083 70.7554V71.4555C139.083 71.7755 138.823 72.0356 138.503 72.0356Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    d: "M138.503 76.7559H137.803C137.483 76.7559 137.223 76.4959 137.223 76.1759V75.4758C137.223 75.1558 137.483 74.8958 137.803 74.8958H138.503C138.823 74.8958 139.083 75.1558 139.083 75.4758V76.1759C139.083 76.4759 138.823 76.7559 138.503 76.7559Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    d: "M138.503 81.4564H137.803C137.483 81.4564 137.223 81.1964 137.223 80.8763V80.1763C137.223 79.8562 137.483 79.5962 137.803 79.5962H138.503C138.823 79.5962 139.083 79.8562 139.083 80.1763V80.8763C139.083 81.1964 138.823 81.4564 138.503 81.4564Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    d: "M138.503 86.1568H137.803C137.483 86.1568 137.223 85.8968 137.223 85.5768V84.8767C137.223 84.5567 137.483 84.2966 137.803 84.2966H138.503C138.823 84.2966 139.083 84.5567 139.083 84.8767V85.5768C139.083 85.8968 138.823 86.1568 138.503 86.1568Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    d: "M138.503 90.8773H137.803C137.483 90.8773 137.223 90.6172 137.223 90.2972V89.5971C137.223 89.2771 137.483 89.0171 137.803 89.0171H138.503C138.823 89.0171 139.083 89.2771 139.083 89.5971V90.2972C139.083 90.6172 138.823 90.8773 138.503 90.8773Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    d: "M138.503 95.5777H137.803C137.483 95.5777 137.223 95.3177 137.223 94.9976V94.2976C137.223 93.9775 137.483 93.7175 137.803 93.7175H138.503C138.823 93.7175 139.083 93.9775 139.083 94.2976V94.9976C139.083 95.3177 138.823 95.5777 138.503 95.5777Z",
    fill: "#ACECC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    d: "M138.503 100.298H137.803C137.483 100.298 137.223 100.038 137.223 99.7181V99.018C137.223 98.698 137.483 98.438 137.803 98.438H138.503C138.823 98.438 139.083 98.698 139.083 99.018V99.7181C139.083 100.018 138.823 100.298 138.503 100.298Z",
    fill: "#ACECC6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    d: "M176.647 -14.5924H21.3125V116.74H176.647V-14.5924Z",
    fill: "url(#paint12_radial_85_12546)"
  })))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    d: "M117.061 44.5131C117.061 44.8931 117.001 45.2931 116.901 45.6531C116.761 46.1732 116.521 46.6532 116.181 47.1133L95.7595 74.4158C94.5594 75.996 92.1991 75.996 90.999 74.3958L75.5976 53.5739C75.2776 53.1339 75.0376 52.6338 74.8975 52.1338C74.6775 51.3537 74.6975 50.5136 74.9175 49.7535C75.0176 49.3935 75.1776 49.0735 75.3776 48.7335L75.3976 48.7134C75.4576 48.6334 75.4976 48.5334 75.5576 48.4334L75.5776 48.4134C75.6576 48.2934 75.7776 48.1734 75.8576 48.0734C75.9176 48.0134 75.9576 47.9534 76.0176 47.8933C76.1777 47.7133 76.3777 47.5533 76.5777 47.4133C77.3578 46.8533 78.2579 46.5932 79.138 46.5932C80.4781 46.5932 81.7782 47.1933 82.6383 48.3334L93.3993 62.6747C93.4593 62.7548 93.5593 62.7548 93.5993 62.6747L109.181 41.8528C110.621 39.9126 113.361 39.5326 115.281 40.9727C115.461 41.1127 115.641 41.2727 115.801 41.4328C115.861 41.4928 115.901 41.5328 115.941 41.5928C116.021 41.6728 116.101 41.7728 116.181 41.8528C116.201 41.8728 116.221 41.8928 116.221 41.9328C116.521 42.3328 116.721 42.7729 116.861 43.2529C117.001 43.673 117.061 44.093 117.061 44.5131Z",
    fill: "#8DFFB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    d: "M116.9 45.6531C116.76 46.1732 116.52 46.6532 116.18 47.1133L95.7584 74.4158C94.5583 75.996 92.1981 75.9959 90.998 74.3958L75.5965 53.5739C75.2765 53.1339 75.0365 52.6338 74.8965 52.1338C74.8965 52.1138 74.9165 52.0937 74.9165 52.0537C75.0165 51.6937 75.1765 51.3737 75.3765 51.0337L75.3965 51.0136C75.4565 50.9336 75.4965 50.8336 75.5566 50.7536C75.5566 50.7336 75.5766 50.7336 75.5766 50.7336C75.6566 50.6136 75.7766 50.4936 75.8566 50.3936C75.9166 50.3336 75.9566 50.2736 76.0166 50.2136C76.1766 50.0536 76.3766 49.8736 76.5766 49.7335C77.3567 49.1735 78.2568 48.9135 79.1369 48.9135C80.477 48.9135 81.7771 49.5135 82.6372 50.6536L93.3982 65.0149C93.4582 65.095 93.5582 65.095 93.5982 65.0149L109.18 44.193C110.62 42.2528 113.36 41.8728 115.28 43.3129C115.46 43.4529 115.64 43.613 115.8 43.773C115.86 43.833 115.9 43.893 115.94 43.933C116.02 44.013 116.1 44.113 116.18 44.193C116.2 44.213 116.22 44.253 116.22 44.273C116.52 44.6731 116.72 45.1131 116.86 45.5932C116.88 45.6132 116.9 45.6331 116.9 45.6531Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    d: "M138.325 65.735C138.325 60.2745 133.884 55.834 128.424 55.834C133.884 55.834 138.325 51.3936 138.325 45.9331C138.325 51.3936 142.765 55.834 148.226 55.834C142.745 55.834 138.325 60.2745 138.325 65.735Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_12546",
    x1: 81.2857,
    y1: 68.2071,
    x2: 85.3707,
    y2: 33.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAED73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1054,
    stopColor: "#D1ED73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#B8EE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#91EF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#79F075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    stopColor: "#77EF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72EDB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_12546",
    x1: 52.4863,
    y1: 59.2329,
    x2: 51.0217,
    y2: 31.9626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#F4693C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5853,
    stopColor: "#F2603C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7561,
    stopColor: "#EF533C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9044,
    stopColor: "#E93F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85_12546",
    x1: 11.0855,
    y1: 33.2559,
    x2: 21.8875,
    y2: 8.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_12546",
    x1: 50.6519,
    y1: 26.182,
    x2: 55.3551,
    y2: 42.2636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_85_12546",
    x1: 22.5307,
    y1: 7.21675,
    x2: 20.5492,
    y2: 23.8039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_85_12546",
    x1: 209.63,
    y1: 80.7326,
    x2: 185.929,
    y2: 55.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_85_12546",
    x1: 184.165,
    y1: 97.1543,
    x2: 162.275,
    y2: 80.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#F4693C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5853,
    stopColor: "#F2603C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7561,
    stopColor: "#EF533C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9044,
    stopColor: "#E93F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_85_12546",
    x1: 137.889,
    y1: 112.126,
    x2: 126.008,
    y2: 88.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_85_12546",
    x1: 178.536,
    y1: 57.3925,
    x2: 197.067,
    y2: 57.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5146,
    stopColor: "#FFD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFC902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8321,
    stopColor: "#FFBE04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9382,
    stopColor: "#FFAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_85_12546",
    x1: 157.766,
    y1: 77.353,
    x2: 173.133,
    y2: 84.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F4673C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5166,
    stopColor: "#F15C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7544,
    stopColor: "#EC4A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#E5303B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E52E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_85_12546",
    x1: 125.188,
    y1: 86.799,
    x2: 136.664,
    y2: 98.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_85_12546",
    x1: 75.8516,
    y1: 3.5,
    x2: 123.852,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86FFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224609,
    stopColor: "#41E183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581664,
    stopColor: "#3EC782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#39957F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_85_12546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6751 25.546) scale(86.1875 81.8264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2408,
    stopColor: "#D0FF86",
    stopOpacity: 0.7589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4141,
    stopColor: "#D4FF8F",
    stopOpacity: 0.5844
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5665,
    stopColor: "#DAFF9F",
    stopOpacity: 0.4308
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#E3FFB5",
    stopOpacity: 0.2893
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#EEFFD2",
    stopOpacity: 0.1561
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9634,
    stopColor: "#FBFFF5",
    stopOpacity: 0.0307659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEntity);
export default __webpack_public_path__ + "static/media/success-entity.94eadcda2b06523defbf7ad0b82bf7fa.svg";
export { ForwardRef as ReactComponent };